// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:49.552Z
// Property: Landmark at Glenmont Station (ID: 6767906449166326)
// Collections: 44 amenities, 22 floorplans (live), 42 photos, 80 POIs, 3 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166326",
  "property_external_id": "30910",
  "property_zillow_url": "https://www.zillow.com/apartments/silver-spring-md/landmark-at-glenmont-station/5XsxSg/",
  "property_apartments_url": "https://www.apartments.com/landmark-at-glenmont-station-silver-spring-md/7yv4wky/",
  "property_google_business_url": "https://www.google.com/maps/place/Landmark+at+Glenmont+Station/data=!4m2!3m1!1s0x0:0x3dc368542df0081c?sa=X&ved=2ahUKEwiQ3Y79tLiSAxUo1vACHUT9EPkQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52814059121",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "landmark-at-glenmont-station",
  "property_name": "Landmark at Glenmont Station",
  "property_website_url": "https://www.landmarkatglenmontstation.com/",
  "property_domain": "https://www.landmarkatglenmontstation.com/",
  "property_address": "2301 Glenallan Avenue",
  "property_full_address": "2301 Glenallan Ave, Silver Spring, MD 20906",
  "property_address_1": "2301 Glenallan Ave",
  "property_address_2": null,
  "property_address_city": "Silver Spring",
  "property_address_state": "MD",
  "property_address_zip_full": "20906-3525",
  "property_address_zip": "20906",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Wheaton-Glenmont",
  "property_address_latitude": "39.0633533",
  "property_address_longitude": "-77.0470916",
  "property_email": "landmark@aionmanagement.com",
  "property_phone": "(301) 933-4848",
  "property_call_tracking_phone": "855-725-2171",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Landmark at Glenmont Station in Silver Spring, MD, comfort meets convenience. Choose from spacious one- or two-bedroom floor plans nestled within a vibrant community, featuring a swimming pool, game room, and pet-friendly amenities. Experience seamless living with our bilingual team, flexible rent, and 24-hour maintenance. Your ideal home awaits!",
  "property_long_description": "**Welcome to Landmark at Glenmont Station – Your Ideal Home in Silver Spring, MD!**\n\nDiscover the perfect blend of comfort and convenience at Landmark at Glenmont Station, where our spacious one- and two-bedroom apartment floor plans cater to a variety of lifestyles. Designed with modern living in mind, our community showcases a range of amenities that elevate your living experience. \n\nEnjoy our beautifully appointed clubhouse and resident lounge, where you can connect with neighbors and partake in engaging resident activities. Stay fit in our well-equipped fitness center or unwind by the sparkling swimming pool and sundeck. If relaxation is what you seek, our yoga studio and picnic area provide the perfect escape.\n\nPet lovers will appreciate our dog park, allowing your furry friends to enjoy the spacious grounds as much as you do. For hassle-free living, we offer flexible rent payment options, a bilingual property team for enhanced communication, and 24-hour emergency maintenance. Plus, with an online resident portal and amenities like Amazon Hub lockers, convenience is always at your fingertips.\n\nOur controlled access building features on-site management, off-street parking, and an elevator for ultimate comfort. Families will enjoy the playground and game room, while our convenient location means you can easily walk to public transportation.\n\nWhether you're looking for short-term leases or a long-term home, you'll find everything you need at Landmark at Glenmont Station. Don't miss out on your opportunity for luxurious living in Silver Spring. \n\n**Find your new home today – browse our availability or schedule a tour to visit our community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-87b4-7356-ae9d-babe8182453d.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property.",
    "public_id": "019fce00-87b4-7356-ae9d-babe8182453d",
    "storage_key": "property/6767906449166326/019fce00-87b4-7356-ae9d-babe8182453d.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "625",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.76",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "All pets must be housebroken; no breeding allowed. Restricted dog breeds include German Shepherds, Akitas, Chow Terriers or mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans (mini pinschers are permitted), Rottweilers, wolf‑dog hybrids, Pit‑bull terriers, Presa Canario or Canary dogs (50% or more mix by veterinary report). Maximum of 2 pets per unit, each up to 100 pounds.",
  "property_pet_policy_description": "We welcome dogs, cats, and service animals. All must be housebroken; no breeding allowed. Restricted dog breeds include German Shepherds, Akitas, Chow Terriers or mixes, American Bulldogs, Bull Staff/Staffordshire Terriers, Dobermans (mini pinschers are permitted), Rottweilers, wolf‑dog hybrids, Pit‑bull terriers, Presa Canario or Canary dogs (50% or more mix by veterinary report). Maximum of 2 pets per unit, each up to 100 lbs. Monthly pet rent is $75 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://landmarkatglenmontstation.loftliving.com/login",
  "property_apply_now_url": "https://www.landmarkatglenmontstation.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0267-652c-704e-9961-478946256c18.webp",
  "property_primary_logo_media": {
    "alt_text": "Landmark Glenmont Station logo",
    "public_id": "019d0267-652c-704e-9961-478946256c18",
    "storage_key": "property/6767906449166326/019d0267-652c-704e-9961-478946256c18.webp",
    "width": 642,
    "height": 247
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0267-652c-704e-9961-478946256c18.webp",
  "property_secondary_logo_media": {
    "alt_text": "Landmark Glenmont Station logo",
    "public_id": "019d0267-652c-704e-9961-478946256c18",
    "storage_key": "property/6767906449166326/019d0267-652c-704e-9961-478946256c18.webp",
    "width": 642,
    "height": 247
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d026b-0126-719d-bfd1-ee17901cdadb.webp",
  "property_icon_media": {
    "alt_text": "Logo for Lumina apartments",
    "public_id": "019d026b-0126-719d-bfd1-ee17901cdadb",
    "storage_key": "property/6767906449166326/019d026b-0126-719d-bfd1-ee17901cdadb.webp",
    "width": 145,
    "height": 145
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d026b-0126-719d-bfd1-ee17901cdadb.webp",
  "property_fav_icon_media": {
    "alt_text": "Logo for Lumina apartments",
    "public_id": "019d026b-0126-719d-bfd1-ee17901cdadb",
    "storage_key": "property/6767906449166326/019d026b-0126-719d-bfd1-ee17901cdadb.webp",
    "width": 145,
    "height": 145
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0267-64f4-770c-adbd-83f782275488.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Landmark Glenmont Station logo",
    "public_id": "019d0267-64f4-770c-adbd-83f782275488",
    "storage_key": "property/6767906449166326/019d0267-64f4-770c-adbd-83f782275488.webp",
    "width": 640,
    "height": 246
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d026b-1c73-74b9-a51e-9406ddc3ae4e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Landmark Glenmont Station logo",
    "public_id": "019d026b-1c73-74b9-a51e-9406ddc3ae4e",
    "storage_key": "property/6767906449166326/019d026b-1c73-74b9-a51e-9406ddc3ae4e.webp",
    "width": 640,
    "height": 246
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "473 - 1230",
  "property_sqft_min": "473",
  "property_sqft_max": "1230",
  "property_price_range": "64 - 2479",
  "property_price_min": "64",
  "property_price_max": "2479",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/LandmarkGlenmontStation/",
  "property_instagram_url": "https://instagram.com/landmarkglenmontstation/#",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJw4d6prrPt4kRHAjwLVRowz0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/landmark-at-glenmont-station-silver-spring",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Landmark at Glenmont Station",
  "property_home_romance_title": "Embrace the Joy of Apartment Living Together",
  "property_home_amenities_blurb": "Welcome to Landmark at Glenmont Station, where modern living meets comfort in Silver Spring, MD. Choose from inviting one and two-bedroom floor plans and enjoy amenities like a pool, fitness center, and pet-friendly spaces. Our dedicated team ensures a vibrant community with events and convenient services at your fingertips.",
  "property_home_floorplans_blurb": "Welcome to Landmark at Glenmont Station in Silver Spring, MD, where stylish living meets convenience. Choose from thoughtfully designed one and two-bedroom apartments, each crafted for comfort and modern living. Browse our available homes today to find the perfect floor plan that suits your lifestyle!",
  "property_home_gallery_blurb": "At Landmark at Glenmont Station, Silver Spring, MD, enjoy modern efficiency in spacious one and two-bedroom floor plans. Indulge in amenities like a scenic pool, yoga studio, and dog park, all nestled within a vibrant community featuring resident events and bilingual support. Picture yourself living in comfort and style!",
  "property_home_neighborhood_blurb": "Welcome to Landmark at Glenmont Station, where comfort meets convenience in Silver Spring! Choose from spacious one or two-bedroom floor plans, and immerse yourself in vibrant local attractions like Brookside Gardens, the AFI Silver Theatre, and the National Capital Trolley Museum. Your new home is surrounded by endless possibilities!",
  "property_home_reviews_blurb": "Experience the charm of Landmark at Glenmont Station, where residents rave about our spacious apartments and friendly staff. One guest exclaims, \"The staff members are so nice and helpful.\" Enjoy a serene community with top-notch amenities just steps away. Join us and become part of this vibrant neighborhood!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Silver Spring, Landmark at Glenmont Station offers easy access to rich cultural experiences and recreational parks. Beyond diverse dining options, explore serene spaces like Brookside Gardens and Glenmont Greenway Urban Park, or catch a film at the historic AFI Silver Theatre. Your new home awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, your ideal home awaits! Choose from one and two-bedroom floor plans designed for comfort. Enjoy unparalleled amenities like a sleek fitness center, inviting swimming pool, and engaging resident activities—all complemented by a bilingual team ready to assist you. ",
  "property_applynow_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, choose from spacious one- and two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a swimming pool, fitness center, and dog park, all while savoring the convenience of a bilingual management team and hassle-free online leasing. Your ideal home awaits!",
  "property_contactus_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, find your perfect home with our stylish one and two-bedroom floor plans. Experience modern living with versatile spaces tailored to your lifestyle. Have questions? Contact our leasing team today and let us help you take the next step toward your new apartment!",
  "property_faqs_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, our diverse floor plans, including one and two-bedroom apartments, cater to your unique lifestyle. Have questions? Our FAQs page holds the key to discovering everything you need to know about living in our vibrant community. ",
  "property_floorplans_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, your ideal living space awaits. Choose between stylish one and two-bedroom floor plans designed for comfort and modern living. Browse our available apartment homes today and picture yourself thriving in a vibrant community just moments from everything you love.",
  "property_gallery_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, picture a vibrant lifestyle where comfort meets community. Choose from spacious one- and two-bedroom floor plans, all while enjoying pet-friendly amenities, a modern fitness center, and relaxing poolside vibes. Elevate your living experience—schedule your visit today!",
  "property_interactivemap_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, our vibrant community offers one and two-bedroom floor plans tailored for modern living. With amenities like a fitness center, dog park, and a delightful sundeck, every moment feels luxurious. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Landmark at Glenmont Station, your furry companions are part of the family! Nestled in vibrant Silver Spring, MD, our community invites well-mannered pets—cats and dogs under 100 lbs—to enjoy a life of comfort. Embrace pet-friendly living while exploring our beautiful surroundings and top-notch amenities.",
  "property_referafriend_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, our inviting one and two-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors—refer a friend to our community today and share the joy of exceptional living together! ",
  "property_residentaccess_blurb": "Welcome to Landmark at Glenmont Station in vibrant Silver Spring, MD, where modern living meets comfort. Choose from stylish one or two-bedroom floor plans tailored to your lifestyle. Access your resident portal for effortless rent payments, maintenance requests, and exclusive community updates – your convenience is just a click away!",
  "property_reviews_blurb": "Experience the charm of Landmark at Glenmont Station, where spacious apartments and attentive staff create a welcoming home. Residents rave about the tremendous value and the standout service from Tan, making tours a highlight. \"The apartments were huge, and the community was nice,\" one reviewer exclaimed—discover your perfect rental today!",
  "property_created_at": "1757006517902",
  "property_scheduletour_blurb": "At Landmark at Glenmont Station in Silver Spring, MD, our thoughtfully designed one and two-bedroom apartments harmonize comfort and style. Experience the vibrant community and stunning amenities that make everyday living exceptional. Curious about life here? Hear directly from our residents and schedule a tour to envision your new home!",
  "property_thankyou_blurb": "Thank you for reaching out to Landmark at Glenmont Station in Silver Spring, MD! Whether you envision a cozy one-bedroom retreat or a spacious two-bedroom haven, our diverse floor plans cater to your lifestyle. Stay tuned—our dedicated team will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Welcome to Landmark at Glenmont Station in Silver Spring, MD, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans. Experience your future home firsthand—take a virtual tour today and immerse yourself in the vibrant lifestyle that awaits you in our welcoming community!",
  "property_copyright": "2025 All Rights Reserved. Landmark at Glenmont Station",
  "property_seo_title_home": "Landmark at Glenmont Station |  Apartments in Silver Spring, MD",
  "property_seo_description_home": "Discover your new home at Landmark at Glenmont Station! Enjoy spacious layouts, vibrant amenities, and a pet-friendly community in Silver Spring, MD.",
  "property_seo_title_floorplans": "Floor Plans | Silver Spring, MD Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Landmark at Glenmont Station in Silver Spring, MD. Choose from stylish one and two-bedroom floor plans tailored for modern living.",
  "property_seo_title_amenities": "Amenities | Silver Spring, MD Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Landmark at Glenmont Station! Enjoy modern apartments, engaging resident events, and top-notch amenities in Silver Spring.",
  "property_seo_title_gallery": "Gallery | Apartments in Silver Spring, MD",
  "property_seo_description_gallery": "Discover life at Landmark at Glenmont Station, Silver Spring, MD. Enjoy pet-friendly amenities and a vibrant community—your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Landmark at Glenmont Station Apartments",
  "property_seo_description_virtualtours": "Step inside Landmark at Glenmont Station in Silver Spring, MD! Take a virtual tour of our stylish one and two-bedroom apartments ready for you to call home.",
  "property_seo_title_interactivemap": "Interactive Map | Landmark at Glenmont Station Apartments",
  "property_seo_description_interactivemap": "Live elevated at Landmark at Glenmont Station! Discover spacious apartments, vibrant amenities, and a welcoming community in Silver Spring, MD.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Silver Spring, MD",
  "property_seo_description_neighborhood": "Uncover the charm of Silver Spring at Landmark at Glenmont Station. Find local favorites, vibrant spots, and everything your new neighborhood has to offer!",
  "property_seo_title_contact": "Contact Us | Landmark at Glenmont Station",
  "property_seo_description_contact": "Experience luxury living at Landmark at Glenmont Station in Silver Spring, MD. Our spacious one- and two-bedroom floor plans await your call. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Silver Spring, MD",
  "property_seo_description_faqs": "Find answers to your questions about Landmark at Glenmont Station in Silver Spring, MD. Learn about our vibrant community, amenities, and floor plans today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Silver Spring, MD",
  "property_seo_description_reviews": "Join the lively Landmark at Glenmont Station community! Hear residents share their experiences in our pet-friendly apartments with great amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Silver Spring, MD",
  "property_seo_description_applynow": "Elevate your lifestyle at Landmark at Glenmont Station! Enjoy pet-friendly amenities, stunning floor plans, and vibrant community activities.",
  "property_seo_title_residentaccess": "Resident Access | Landmark at Glenmont Station",
  "property_seo_description_residentaccess": "Log in to the Landmark at Glenmont Station portal to manage rent, request maintenance, and connect with your Silver Spring community!",
  "property_seo_title_referafriend": "Refer A Friend | Landmark at Glenmont Station",
  "property_seo_description_referafriend": "Refer a friend to Landmark at Glenmont Station! Build a vibrant community in Silver Spring, MD, where great neighbors make life even better. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Landmark at Glenmont Station",
  "property_seo_description_scheduletour": "Experience comfort and luxury at Landmark at Glenmont Station in Silver Spring, MD. Schedule your tour today and envision your new life with us!",
  "property_seo_title_privacy": "Privacy Policy | Landmark at Glenmont Station",
  "property_seo_description_privacy": "Experience peace of mind at Landmark at Glenmont Station. Your privacy matters to us! Read our policy for how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Landmark at Glenmont Station",
  "property_seo_description_accessibility": "Embrace inclusivity at Landmark at Glenmont Station. Our commitment to accessibility ensures everyone feels at home in Silver Spring, MD. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Landmark at Glenmont Station",
  "property_seo_description_sitemap": "Uncover the path to your ideal home at Landmark at Glenmont Station in Silver Spring, MD. Check our sitemap for a seamless journey through community offerings!",
  "property_seo_title_thankyou": "Thank You | Landmark at Glenmont Station",
  "property_seo_description_thankyou": "Thank you for reaching out to Landmark at Glenmont Station! A team member will be in touch soon to help you find your perfect home in Silver Spring, MD.",
  "property_seo_title_pets": "Pet Policy | Apartments in Silver Spring, MD",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293669654",
  "amenities": [
    {
      "id": "custom_70502fd8-080d-4333-af67-013a97cc9a3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_251a1cc9-1d02-42a5-bbb7-7cb52cdc919b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19bea62b-432b-47d3-a454-8620aa2b1bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f9ba33a-43c2-48ba-831a-861fbed665d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4da60d97-3615-42f1-9b3c-d6e1e7f7a7bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adbd7765-3b4e-4fad-aca3-13586d22cd8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment and Maintenance Requests",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3f1500b-852f-49b6-9c8e-b3ad62b6d210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fde57c04-38f3-4e64-b67f-45fb98fae2bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4644a424-f2cc-494d-b8fa-a74a3be23f4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf8b1af0-f007-43c4-a4c7-79c0319d9dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c0e3178-cb32-4298-9444-893f018ebec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Studio with On-Demand Fitness",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d35613fd-defe-4f64-aece-5c5a2fbf1d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e817add-12e7-454f-9ddc-c478bdf20fa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f97e14a4-42b0-48da-ae33-1c156e64c909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_221aa88f-fce2-4f7c-ab05-9c9eb2c7a9c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8beb03e-b49f-42a7-b68d-0658e74231da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00b2eb4a-d03a-4f8e-85f3-fef6a9b97d66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Available",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc7d357e-88c2-489f-8914-39506f9660a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios and Balconies",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d84c5d0f-7480-4b51-b96d-399087804abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84e06834-5854-4129-9d8b-79de05f5b4c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dfae4886-da30-48b7-ad68-5f56a91a49db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances *",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fa5d84c-1fbd-48b4-9a01-8c101c62459d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood-Like Plank Flooring*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f79ba5dd-151f-4392-89eb-f19099f76b64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18b07d3e-ed9b-4105-9717-b45c6248239f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer in Home",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f499c34f-c348-480f-80ea-50cfdbd3ec37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Close to the 536-Acre Wheaton Regional Park",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a8e8bde-013e-4c97-ba65-4fca921ed5b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Close to the Shops at Westfield Wheaton Plaza",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89e8d24a-943a-4231-957e-926255ed3678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Natural Trails for Biking and Hiking",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae55a0fa-0d50-4dd0-80bd-b56d54d74460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Downtown Silver Spring",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f934a8e8-3e81-4489-8d97-8510c4595d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Quick Access to Washington DC",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d44294f8-e787-4f82-b386-ea66cfad97a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Short Drive from I-495, the ICC, and Connecticut Avenue",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12acda57-968c-41d8-85eb-cf63997921a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38d7bb50-4858-4c2b-b845-361ca963949c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "0.3 Miles to Glenmont Metro Station",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d799a64-22dc-49ab-aa7f-b477bbfb52bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Amazon Hub Package Locker",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cdf1fc5f-e8e1-4afc-acf6-716938869766",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5eaa03d9-28dc-432a-8ece-e8a2a57358df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling and Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b50d757-7b4e-4e17-ad2c-992831eb3b64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5cc53d64-b5f6-4df8-b6af-910cb743bd29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19725c6e-a7fb-4026-aac7-edcb59fb5519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8ad7ac7-a34c-4574-8f07-77935b66183b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2f766cd-7106-41e7-8701-b26a56730ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92699319-14cc-4ce3-a9d7-531791064f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eadf4560-f101-49fb-9018-9e2b54dec906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_75b70321-181e-4e19-8330-9b2fccfc8296",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc8653c7-caf4-4776-a41d-4c0df2251145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "external_id": "false",
      "title": "Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_14bdf339-f961-4f2b-bc68-4bed1d5e86d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c51-7223-817b-222c183a3740.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black refrigerator, oven, and dishwasher.",
        "public_id": "019fce00-9c51-7223-817b-222c183a3740",
        "storage_key": "property/6767906449166326/019fce00-9c51-7223-817b-222c183a3740.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Step into this well-appointed kitchen featuring sleek dark wood cabinetry, a modern black appliance suite, and ample counter space for meal preparation.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, black appliances, light countertop, gray walls, and wood-look flooring at Landmark at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0007_Landmark_K1_05-07-23_07_36_g7pkj2.jpg"
    },
    {
      "id": "custom_fd544eff-8d42-46a3-b4c6-a0db3e62a93d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c5e-709c-8380-c625d926fba8.webp",
      "image_media": {
        "alt_text": "Dining room with a table for six, elegant china cabinet, and abstract wall art.",
        "public_id": "019fce00-9c5e-709c-8380-c625d926fba8",
        "storage_key": "property/6767906449166326/019fce00-9c5e-709c-8380-c625d926fba8.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy elegant dinners in this spacious dining room featuring a large table set for six, a charming china cabinet, and tasteful abstract wall art.",
      "link": "",
      "alt_text": "Dining room with a table set for a meal, a hutch, and a doorway to a kitchen at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0008_Landmark_DR1_05-07-23_07_43_slj1rs.jpg"
    },
    {
      "id": "custom_a331e97b-bc59-4bdf-a427-077666aa5e36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c68-73cd-835a-efebc37c2816.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a large bed, dresser, and full-length mirror.",
        "public_id": "019fce00-9c68-73cd-835a-efebc37c2816",
        "storage_key": "property/6767906449166326/019fce00-9c68-73cd-835a-efebc37c2816.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a king-sized bed, ample storage, and elegant decor. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "Bedroom interior with a bed, dresser, mirror, window with curtains, and neutral-colored carpet at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0010_Landmark_BR2_05-07-23_08_13_unti1i.jpg"
    },
    {
      "id": "custom_feb20dd8-2805-4cbc-b2dd-8589b34c619c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-9c5e-709c-8380-c85aeba797d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fce00-9c5e-709c-8380-c85aeba797d6",
        "storage_key": "property/6767906449166326/019fce00-9c5e-709c-8380-c85aeba797d6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, sleek granite countertops, stainless steel appliances including a dishwasher, microwave, oven, and refrigerator. A separate laundry area with a washer and dryer is visible in the background.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and gray countertops at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0006_Landmark_K3_05-07-23_08_23_iihcft.jpg"
    },
    {
      "id": "custom_5e6e6215-f5ba-453b-8153-c6848d23bac9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-a7fd-7759-80b0-d9c81c6c9ed9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019fce00-a7fd-7759-80b0-d9c81c6c9ed9",
        "storage_key": "property/6767906449166326/019fce00-a7fd-7759-80b0-d9c81c6c9ed9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A beautifully appointed kitchen featuring dark wood cabinetry, sleek black appliances including a refrigerator, dishwasher, and oven, complemented by granite countertops and ample counter space for meal preparation.",
      "link": "",
      "alt_text": "Kitchen with dark brown cabinets, black appliances, and granite countertops at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0001_Landmark_K2_05-07-23_07_39_c8woax.jpg"
    },
    {
      "id": "custom_bda45ace-03eb-4e44-850d-28c92238a3a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-a938-7114-878a-aa6f75814af1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a round dining table.",
        "public_id": "019fce00-a938-7114-878a-aa6f75814af1",
        "storage_key": "property/6767906449166326/019fce00-a938-7114-878a-aa6f75814af1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, stainless steel appliances, and a convenient dining area.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, stainless steel appliances, granite countertops, and a dining table at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0022_2_x5bcu7.jpg"
    },
    {
      "id": "custom_832293be-40c6-49e6-b192-c3408805386c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-a965-74bd-9deb-1013239ffbcc.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four, leading to a kitchen with dark cabinets and stainless steel appliances.",
        "public_id": "019fce00-a965-74bd-9deb-1013239ffbcc",
        "storage_key": "property/6767906449166326/019fce00-a965-74bd-9deb-1013239ffbcc.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this spacious area, perfect for entertaining guests. The adjacent kitchen features modern dark cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Dining room with round table, place settings, chairs, and view into kitchen and living room at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0002_Landmark_DR2_05-07-23_08_20_gmtwel.jpg"
    },
    {
      "id": "custom_405d0c5d-90e8-47c9-8eed-d83622d41e69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-abdb-7677-aaf6-ce2c93368f63.webp",
      "image_media": {
        "alt_text": "Living room and dining area with plush seating, a coffee table with drinks and pastries, and a round dining table.",
        "public_id": "019fce00-abdb-7677-aaf6-ce2c93368f63",
        "storage_key": "property/6767906449166326/019fce00-abdb-7677-aaf6-ce2c93368f63.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Experience the spacious living and dining areas, perfect for relaxing or entertaining. This inviting space features comfortable seating and elegant decor.",
      "link": "",
      "alt_text": "Living and dining room with furniture, decor, wood floor, and doorway to another room at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0004_Landmark_LR2_05-07-23_08_48_lkbalh.jpg"
    },
    {
      "id": "custom_caef9959-ec53-438d-88a3-7a6be7af2da5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-b429-759c-8e8f-fc0f857f6da1.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for six, a china cabinet, and a painting on the wall.",
        "public_id": "019fce00-b429-759c-8e8f-fc0f857f6da1",
        "storage_key": "property/6767906449166326/019fce00-b429-759c-8e8f-fc0f857f6da1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy meals and entertaining in this spacious dining room, complete with a elegant dining set and stylish china cabinet.",
      "link": "",
      "alt_text": "Dining room with a table set for a meal, large china cabinet, and artwork at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0000_Landmark_LR3_05-07-23_08_17_j6i6ug.jpg"
    },
    {
      "id": "custom_b17dd44a-7ac6-4b25-b794-8130d646e68e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-c164-7324-83c7-0d512420d844.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and balcony access",
        "public_id": "019fce00-c164-7324-83c7-0d512420d844",
        "storage_key": "property/6767906449166326/019fce00-c164-7324-83c7-0d512420d844.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, modern coffee table, and a dining area, with access to a private balcony.",
      "link": "",
      "alt_text": "Living room with gray sofa, coffee table, rug, balcony, and large windows at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0005_Landmark_LR1_05-07-23_07_51_rwnu1q.jpg"
    },
    {
      "id": "custom_4a223cc0-da1d-4c12-87f1-e076f1cc36c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-cddc-77f2-a802-1f41a16f4692.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed and dresser, view of a hallway leading to closets and bathroom.",
        "public_id": "019fce00-cddc-77f2-a802-1f41a16f4692",
        "storage_key": "property/6767906449166326/019fce00-cddc-77f2-a802-1f41a16f4692.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a dresser with decor, and views into a hallway with ample closet space and a private bathroom.",
      "link": "",
      "alt_text": "Bedroom with bed, wooden dressers, and access to a bathroom and hallway at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/Landmark_BTH_05-07-23_08_26_0003_Landmark_BR3_05-07-23_08_51_b1yz6k.jpg"
    },
    {
      "id": "custom_0fbac786-9505-4877-8237-d9901cccfd1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-cde4-7520-b079-c500f44e8dcd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and glass-enclosed shower.",
        "public_id": "019fce00-cde4-7520-b079-c500f44e8dcd",
        "storage_key": "property/6767906449166326/019fce00-cde4-7520-b079-c500f44e8dcd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A clean and updated bathroom featuring a vanity with a sink, a toilet, and a spacious shower with a glass enclosure.",
      "link": "",
      "alt_text": "Bathroom with white walls, a vanity, toilet, and a glass shower enclosure at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0032_DSC_3779_vrp4yh.jpg"
    },
    {
      "id": "custom_474073ea-b399-42c9-a594-f96d39d8e852",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-d712-7715-8aff-5f02b1101637.webp",
      "image_media": {
        "alt_text": "Modern lounge area with patterned couches, accent chairs, coffee table, and TV.",
        "public_id": "019fce00-d712-7715-8aff-5f02b1101637",
        "storage_key": "property/6767906449166326/019fce00-d712-7715-8aff-5f02b1101637.webp",
        "width": 1610,
        "height": 1075
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a large screen TV, and vibrant decor. Perfect for socializing or enjoying some downtime.",
      "link": "",
      "alt_text": "Lounge area with black and yellow patterned furniture, dark gray wall with TV, and colorful rug at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/DSC_3872_s9fzbo.jpg"
    },
    {
      "id": "custom_854bccd8-cfc4-40d0-92c6-cf821f01ed6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-d92a-7235-b891-4833c18d68c1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sectional sofa, colorful rug, and bar seating.",
        "public_id": "019fce00-d92a-7235-b891-4833c18d68c1",
        "storage_key": "property/6767906449166326/019fce00-d92a-7235-b891-4833c18d68c1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, a vibrant area rug, and convenient bar-style tables.",
      "link": "",
      "alt_text": "Lounge area with a colorful sectional, high-top table, and vibrant rug. Overhead, colorful ring lights at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0052_DSC_3993_asw1a5.jpg"
    },
    {
      "id": "custom_48eb00f8-cc04-4971-b250-4177e1a7af3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-da46-764a-83d7-6a03e1895b54.webp",
      "image_media": {
        "alt_text": "Yoga mats and a plyo box are laid out in a studio with mirrored walls and abstract art.",
        "public_id": "019fce00-da46-764a-83d7-6a03e1895b54",
        "storage_key": "property/6767906449166326/019fce00-da46-764a-83d7-6a03e1895b54.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Energize your routine in our state-of-the-art fitness studio, complete with yoga mats and ample space for your workout.",
      "link": "",
      "alt_text": "Yoga studio with framed art on teal wall, wood floor, and yoga mats at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0004_DSC_9333_j6jiw2.jpg"
    },
    {
      "id": "custom_2840f5de-0a49-4672-886e-d96ebb764c98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-e5ce-715e-9f7c-837da44d9d75.webp",
      "image_media": {
        "alt_text": "Modern gym with yoga mats, free weights, and a smart mirror.",
        "public_id": "019fce00-e5ce-715e-9f7c-837da44d9d75",
        "storage_key": "property/6767906449166326/019fce00-e5ce-715e-9f7c-837da44d9d75.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and a smart mirror for guided workouts.",
      "link": "",
      "alt_text": "Gym interior with workout equipment and mats on a wooden floor. Dark blue walls, black ceiling, and open doorway at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0016_DSC_3936_fzfs9v.jpg"
    },
    {
      "id": "custom_0d353413-4786-42bd-ae57-eb8f7ed3751b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-f37c-7218-b731-ed29f90d3b9b.webp",
      "image_media": {
        "alt_text": "Foosball table and conference table with orange chairs in a community room.",
        "public_id": "019fce00-f37c-7218-b731-ed29f90d3b9b",
        "storage_key": "property/6767906449166326/019fce00-f37c-7218-b731-ed29f90d3b9b.webp",
        "width": 1580,
        "height": 1055
      },
      "title": "Community",
      "description": "Enjoy entertainment and meeting spaces with a foosball table and a large conference table with seating in our community room.",
      "link": "",
      "alt_text": "Game room with foosball table, dark walls, and orange chairs at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/DSC_3874_c8qd4q.jpg"
    },
    {
      "id": "custom_c1608d8e-7cf7-4283-8314-a5c957d062a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool. Relax on the lounge chairs or take in the view of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Pool with lounge chairs and lifeguard stand, building in background at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0013_DSC_4186_lb7vzc.jpg"
    },
    {
      "id": "custom_c98f4009-82b4-458e-aeb9-dfef4aa79255",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fcad-71df-8457-94a14e9a2c75.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fce00-fcad-71df-8457-94a14e9a2c75",
        "storage_key": "property/6767906449166326/019fce00-fcad-71df-8457-94a14e9a2c75.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool with orange umbrellas and lounge chairs, surrounded by trees and a brick building at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0011_DSC_4206_gbtwmb.jpg"
    },
    {
      "id": "custom_10c21f9c-bb23-4a1c-89b2-0fea0e012406",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fe42-76c9-bf55-db11512e04e5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019fce00-fe42-76c9-bf55-db11512e04e5",
        "storage_key": "property/6767906449166326/019fce00-fe42-76c9-bf55-db11512e04e5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. A perfect oasis for residents to enjoy the sunshine and cool off.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs, orange and blue umbrellas, and a brick building on a sunny day at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0010_DSC_4214_shaws4.jpg"
    },
    {
      "id": "custom_f460ad9b-1fc6-4782-86ef-58158655be95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fe05-713b-b29f-32d62cc909b8.webp",
      "image_media": {
        "alt_text": "Package lockers with a hub by Amazon logo and touchscreen interface.",
        "public_id": "019fce00-fe05-713b-b29f-32d62cc909b8",
        "storage_key": "property/6767906449166326/019fce00-fe05-713b-b29f-32d62cc909b8.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Secure package lockers are available for residents' convenience, featuring a hub by Amazon system with a touchscreen interface.",
      "link": "",
      "alt_text": "Dark blue Amazon Hub locker system in a room with light-colored flooring at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0023_DSC_3805_xaq0fc.jpg"
    },
    {
      "id": "custom_e312ebff-7a41-45ec-ad70-6595ba142f34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-06a4-7068-9d33-3752bbb98ebf.webp",
      "image_media": {
        "alt_text": "Playground with slides in a grassy area with trees and buildings in the background.",
        "public_id": "019fce01-06a4-7068-9d33-3752bbb98ebf",
        "storage_key": "property/6767906449166326/019fce01-06a4-7068-9d33-3752bbb98ebf.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with slides and ample space for children to play. Located amidst lush greenery and close to apartment buildings.",
      "link": "",
      "alt_text": "Playground with green slides, climbing structure, and trees at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0007_DSC_5243_pxcrzd.jpg"
    },
    {
      "id": "custom_bdf80f5a-802f-4d9c-927e-f253cf5c2248",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-092b-7397-9d8f-7426e8e6dd44.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a fire hydrant.",
        "public_id": "019fce01-092b-7397-9d8f-7426e8e6dd44",
        "storage_key": "property/6767906449166326/019fce01-092b-7397-9d8f-7426e8e6dd44.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, complete with agility equipment for your furry friends to play and train.",
      "link": "",
      "alt_text": "Dog park with agility equipment on green grass, fenced off, with apartment building in the background at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0009_DSC_4223_oqtnb7.jpg"
    },
    {
      "id": "custom_0bae0ae6-a440-4569-8d6a-dd681a394f24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-0aeb-70d8-9b74-ce34f794c9c7.webp",
      "image_media": {
        "alt_text": "Exterior view of the Landmark apartment building with purple flowers in the foreground.",
        "public_id": "019fce01-0aeb-70d8-9b74-ce34f794c9c7",
        "storage_key": "property/6767906449166326/019fce01-0aeb-70d8-9b74-ce34f794c9c7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming exterior of the Landmark apartment building, featuring a well-maintained facade and blooming purple flowers, creating an inviting entrance.",
      "link": "",
      "alt_text": "Large brick building with a covered entrance, purple flowers in the foreground, and a blue sky at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_at_glenmont_station_0045_DSC_3705_hehjkl.jpg"
    },
    {
      "id": "custom_f7ee1b1e-15db-40f4-a40a-98c4346fa16d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-0b49-747f-884d-d4eba5511d9e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees in autumn.",
        "public_id": "019fce01-0b49-747f-884d-d4eba5511d9e",
        "storage_key": "property/6767906449166326/019fce01-0b49-747f-884d-d4eba5511d9e.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Experience comfortable living in our apartment community, nestled amongst beautiful autumn foliage.",
      "link": "",
      "alt_text": "Aerial view of a multistory apartment building and townhouses surrounded by trees under a clear sky at Glenmont Station in Silver Spring, MD.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/9dba007e/dms3rep/multi/landmark_0019_DJI_0710_wq5x6w.jpg"
    },
    {
      "id": "custom_3654cb81-2198-493d-9611-b491b1bb0ce1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-15b0-71ac-9cd3-e768c9775d45.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "01a15a45-15b0-71ac-9cd3-e768c9775d45",
        "storage_key": "property/6767906449166326/01a15a45-15b0-71ac-9cd3-e768c9775d45.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "",
      "description": "",
      "link": "",
      "alt_text": "",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15ba926f-dbbc-4891-aa0c-059d7a2ab4a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-d1a0-7058-a987-0fe58b7d9a8f.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed and ensuite bathroom.",
        "public_id": "01a15a45-d1a0-7058-a987-0fe58b7d9a8f",
        "storage_key": "property/6767906449166326/01a15a45-d1a0-7058-a987-0fe58b7d9a8f.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in this spacious primary bedroom featuring a king-size bed and direct access to an ensuite bathroom. The room offers a comfortable and serene atmosphere.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed and ensuite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0940b38-c3c2-4807-9a57-a32ec6b3cfc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-bc80-713a-8c40-7b8cbff794e6.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets and black appliances.",
        "public_id": "01a15a45-bc80-713a-8c40-7b8cbff794e6",
        "storage_key": "property/6767906449166326/01a15a45-bc80-713a-8c40-7b8cbff794e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Compact kitchen with wooden cabinets, black refrigerator, stove, and dishwasher. Features a sink and counter space, with a view of a hallway.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa3a5a2b-dcf1-4302-a371-070cc81d9ffe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-aa16-766f-b3ce-c9bed6f50215.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, shower curtain, vanity, and mirror.",
        "public_id": "01a15a45-aa16-766f-b3ce-c9bed6f50215",
        "storage_key": "property/6767906449166326/01a15a45-aa16-766f-b3ce-c9bed6f50215.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, shower with a white curtain, a vanity with a sink, and a large mirror.",
      "link": "",
      "alt_text": "Bathroom with toilet, shower curtain, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89db6b6c-7ab4-4aa9-b1ab-fcde2e76ab48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-acf1-741f-b376-b5e948f6a180.webp",
      "image_media": {
        "alt_text": "Game room with a pool table, shuffleboard, and neon sign.",
        "public_id": "01a15a45-acf1-741f-b376-b5e948f6a180",
        "storage_key": "property/6767906449166326/01a15a45-acf1-741f-b376-b5e948f6a180.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our vibrant game room, featuring a pool table, shuffleboard, and a neon sign that says \"Work Hard, Play Harder\".",
      "link": "",
      "alt_text": "Game room with a pool table, shuffleboard, and neon sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe1cc745-dc0d-4f5b-94aa-74fef82c98af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-a83b-75f8-abd6-cfc539a270de.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with a signage for Landmark Glenmont Station.",
        "public_id": "01a15a45-a83b-75f8-abd6-cfc539a270de",
        "storage_key": "property/6767906449166326/01a15a45-a83b-75f8-abd6-cfc539a270de.webp",
        "width": 1859,
        "height": 1239
      },
      "title": "Community",
      "description": "Welcome to Landmark Glenmont Station, featuring a grand exterior entrance and welcoming signage.",
      "link": "",
      "alt_text": "Exterior building entrance with a signage for Landmark Glenmont Station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74189321-709b-4760-85e7-4df4314daedd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-b006-7105-ae39-02d99c032be1.webp",
      "image_media": {
        "alt_text": "Landmark Glenmont Station apartment building entrance with signage and landscaping.",
        "public_id": "01a15a45-b006-7105-ae39-02d99c032be1",
        "storage_key": "property/6767906449166326/01a15a45-b006-7105-ae39-02d99c032be1.webp",
        "width": 2059,
        "height": 1373
      },
      "title": "Community",
      "description": "Welcome to Landmark Glenmont Station, featuring a beautifully landscaped entrance and clear building signage. Discover your new home in this vibrant community.",
      "link": "",
      "alt_text": "Landmark Glenmont Station apartment building entrance with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52b83b7c-1d54-4c5b-88d7-6ec5a7819032",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-4a73-730a-b159-2d44ee449950.webp",
      "image_media": {
        "alt_text": "Living room with a bookshelf, sofa, and dining area visible.",
        "public_id": "01a15a45-4a73-730a-b159-2d44ee449950",
        "storage_key": "property/6767906449166326/01a15a45-4a73-730a-b159-2d44ee449950.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Spacious living area with modern furnishings, including a bookshelf and comfortable sofa, leading into a dining space.",
      "link": "",
      "alt_text": "Living room with a bookshelf, sofa, and dining area visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8c74050-9fa2-4abe-84b4-a1013955c7ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-75d7-733d-a4cb-d2f3de699784.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and granite countertops.",
        "public_id": "01a15a45-75d7-733d-a4cb-d2f3de699784",
        "storage_key": "property/6767906449166326/01a15a45-75d7-733d-a4cb-d2f3de699784.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this modern kitchen featuring white cabinetry, sleek black appliances including a refrigerator, microwave, and stove, and stylish granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c231fa78-1e02-4de7-9eb9-f6b0885c424a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-6cbd-74fc-8ad3-41b6ba06326d.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a large TV, media console, sofa, and view of the outdoors.",
        "public_id": "01a15a45-6cbd-74fc-8ad3-41b6ba06326d",
        "storage_key": "property/6767906449166326/01a15a45-6cbd-74fc-8ad3-41b6ba06326d.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a wall-mounted TV, modern media console, comfortable sofa, and large windows with a view of the surrounding greenery.",
      "link": "",
      "alt_text": "Living room and dining area with a large TV, media console, sofa, and view of the outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4841a264-b2a8-434b-b425-624cc14a3129",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-67c3-750c-b1f4-db84ddcd2022.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, nightstand, and a plant.",
        "public_id": "01a15a45-67c3-750c-b1f4-db84ddcd2022",
        "storage_key": "property/6767906449166326/01a15a45-67c3-750c-b1f4-db84ddcd2022.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a spacious bed and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a large bed, nightstand, and a plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15340891-3a72-48af-b805-a4eb6034e47d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-4d33-7598-a7aa-a6afeab297db.webp",
      "image_media": {
        "alt_text": "Living and dining area with sectional sofa, desk, and dining table.",
        "public_id": "01a15a45-4d33-7598-a7aa-a6afeab297db",
        "storage_key": "property/6767906449166326/01a15a45-4d33-7598-a7aa-a6afeab297db.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sectional sofa, a functional desk space, and a stylish dining set, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with sectional sofa, desk, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0860cc85-27f5-420d-900f-88a6c063903c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-5f3f-760b-8f2f-f6bd2cb6d31f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in apartment",
        "public_id": "01a15a45-5f3f-760b-8f2f-f6bd2cb6d31f",
        "storage_key": "property/6767906449166326/01a15a45-5f3f-760b-8f2f-f6bd2cb6d31f.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Bright and airy dining area and kitchen in apartment, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Dining area and kitchen in apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b719385-27d5-4fbe-bef2-aff14983fdbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-3873-75af-bc67-e006924798f8.webp",
      "image_media": {
        "alt_text": "Gym with weight rack, barbells, and weight plates.",
        "public_id": "01a15a45-3873-75af-bc67-e006924798f8",
        "storage_key": "property/6767906449166326/01a15a45-3873-75af-bc67-e006924798f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center featuring a weight rack, barbells, and ample weight plates for your workout needs.",
      "link": "",
      "alt_text": "Gym with weight rack, barbells, and weight plates.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39090327-297b-4be4-a259-7aa2307e889b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-26e6-73ab-931d-ff45e8350ecd.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstand, and closet.",
        "public_id": "01a15a45-26e6-73ab-931d-ff45e8350ecd",
        "storage_key": "property/6767906449166326/01a15a45-26e6-73ab-931d-ff45e8350ecd.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "A cozy and well-lit bedroom featuring a comfortable bed, modern nightstand, and spacious closet, perfect for relaxation and storage.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4617b491-7e0f-4fc2-8375-46325b261c02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a45-3cbd-7675-b852-7aca53d85b53.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, chairs, and a view into the kitchen.",
        "public_id": "01a15a45-3cbd-7675-b852-7aca53d85b53",
        "storage_key": "property/6767906449166326/01a15a45-3cbd-7675-b852-7aca53d85b53.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this inviting dining area, featuring a stylish round table and comfortable seating. The open doorway offers a glimpse into the adjacent kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Dining area with a round table, chairs, and a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c58b27e3-f7aa-4d48-a56d-62d75d667378",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/01a15a44-fa19-7133-b974-a9aa43370c41.webp",
      "image_media": {
        "alt_text": "Dumbbell rack with various weights in a fitness center.",
        "public_id": "01a15a44-fa19-7133-b974-a9aa43370c41",
        "storage_key": "property/6767906449166326/01a15a44-fa19-7133-b974-a9aa43370c41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Fully equipped fitness center with a wide selection of dumbbells for your workout needs.",
      "link": "",
      "alt_text": "Dumbbell rack with various weights in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a876dc7e-ae4a-4616-a219-b4f44529a8c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Stained Glass Pub - Glenmont",
      "poi_type": "Restaurants",
      "poi_address": "12510 Layhill Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "Casual neighborhood watering hole for TV sports, live music & a hearty pub fare menu.",
      "poi_long_description": "Casual neighborhood watering hole for TV sports, live music & a hearty pub fare menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-22aa-70bd-96cd-02723c9f1b60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-22aa-70bd-96cd-02723c9f1b60",
        "storage_key": "property/6767906449166326/019fce01-22aa-70bd-96cd-02723c9f1b60.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.stainedglasspub.net/glenmont-menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=10909169214844954877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stained-glass-pub---glenmont",
      "poi_latitude": "39.0616647",
      "poi_longitude": "-77.05123999999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 301-933-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46b-75be-b2f7-c01903f39322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46b-75be-b2f7-c01903f39322",
        "storage_key": "property/6767906449166326/019d0268-c46b-75be-b2f7-c01903f39322.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTaf963Pt4kR_eh1BZonZZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_19451fb3-39e7-45f8-b53b-53eda71e39e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Trippy Tacos",
      "poi_type": "Restaurants",
      "poi_address": "12134 Georgia Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "Bistro featuring handmade tortillas and burritos, plus pupusas and ramen.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-242f-70c8-97c4-8a3a30f21d6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-242f-70c8-97c4-8a3a30f21d6f",
        "storage_key": "property/6767906449166326/019fce01-242f-70c8-97c4-8a3a30f21d6f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://trippytacos240.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8697495719362440598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trippy-tacos",
      "poi_latitude": "39.05395",
      "poi_longitude": "-77.0510777",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-949-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp__saTfPt4kRli0UhEa2s3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4390c094-da1e-4b69-b818-03620e223d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Regina's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11423 Georgia Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Casual eatery specializing in staples from Italy and the Mediterranean in a relaxed setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-22f7-719c-b11b-13901cec1bde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-22f7-719c-b11b-13901cec1bde",
        "storage_key": "property/6767906449166326/019fce01-22f7-719c-b11b-13901cec1bde.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://reginasrestaurantmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2155114110807782572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reginas-restaurant",
      "poi_latitude": "39.0421936",
      "poi_longitude": "-77.05135",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-933-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYbJdbPPt4kRrDQhkd2A6B0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f01909b-7652-46f6-8f6b-95cf9f68c542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "The Limerick Pub",
      "poi_type": "Restaurants",
      "poi_address": "11301 Elkin St, Wheaton, MD 20902, USA",
      "poi_short_description": "Traditional Irish pub for bangers & mash, Guinness & live folk music throughout the week.",
      "poi_long_description": "Traditional Irish pub for bangers & mash, Guinness & live folk music throughout the week.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-21ce-7410-a526-29ffaa60a282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-21ce-7410-a526-29ffaa60a282",
        "storage_key": "property/6767906449166326/019fce01-21ce-7410-a526-29ffaa60a282.webp",
        "width": 320,
        "height": 319
      },
      "poi_business_url": "http://www.thelimerickpub.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15180465330332124946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-limerick-pub",
      "poi_latitude": "39.0403978",
      "poi_longitude": "-77.0502182",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-946-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46b-75be-b2f7-c01903f39322.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46b-75be-b2f7-c01903f39322",
        "storage_key": "property/6767906449166326/019d0268-c46b-75be-b2f7-c01903f39322.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQbAWxvPt4kREkeU08nYq9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95d4abf8-e0b6-4fd1-9211-d928d1ee068c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Taqueria Sabor Mixteco",
      "poi_type": "Restaurants",
      "poi_address": "2462 Ennalls Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "Cozy restaurant for traditional Mexican fare such as enchiladas, tacos and flan.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-2889-7167-952c-59e9c9aa75a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-2889-7167-952c-59e9c9aa75a0",
        "storage_key": "property/6767906449166326/019fce01-2889-7167-952c-59e9c9aa75a0.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://sabormixteco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16340825040405801779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-sabor-mixteco",
      "poi_latitude": "39.04014979999999",
      "poi_longitude": "-77.05242120000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 240-500-3833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XOh4QHPt4kRMysy_stFxuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04463f2b-439a-49d5-bf9f-deab94a01959",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Ruan Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11407 Amherst Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Bustling, bare-bones restaurant features Thai classics plus specialties like deep-fried watercress.",
      "poi_long_description": "Bustling, bare-bones restaurant features Thai classics plus specialties like deep-fried watercress.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-2a08-727c-a7d5-2a9021802f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-2a08-727c-a7d5-2a9021802f57",
        "storage_key": "property/6767906449166326/019fce01-2a08-727c-a7d5-2a9021802f57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ruanthaiwheaton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791126712800294566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruan-thai-restaurant",
      "poi_latitude": "39.041719",
      "poi_longitude": "-77.047609",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-942-0075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWS4a2QTPt4kRprawSpLIwZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e082bd2f-3ca2-4d6d-bcdb-96297c48efb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Ren's Ramen",
      "poi_type": "Restaurants",
      "poi_address": "11403 Amherst Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "Hopping Japanese eatery ladling out bowls of ramen in a small, no-frills setting.",
      "poi_long_description": "Hopping Japanese eatery ladling out bowls of ramen in a small, no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-2a78-715f-87bf-eef72bb19e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-2a78-715f-87bf-eef72bb19e3a",
        "storage_key": "property/6767906449166326/019fce01-2a78-715f-87bf-eef72bb19e3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12622681384302934462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rens-ramen",
      "poi_latitude": "39.041675",
      "poi_longitude": "-77.04769999999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-933-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2aMrzKzPt4kRvvlPWNfFLK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2740a5f5-930b-483d-83f0-076d202648c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Los Chorros Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2420 Blueridge Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "Casual neighborhood restaurant supplying Salvadoran specialties & a few Mexican meals.",
      "poi_long_description": "Casual neighborhood restaurant supplying Salvadoran specialties & a few Mexican meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-2b4c-7518-b4fe-a6c1690dbc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-2b4c-7518-b4fe-a6c1690dbc39",
        "storage_key": "property/6767906449166326/019fce01-2b4c-7518-b4fe-a6c1690dbc39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://loschorrosrestaurant.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12384912820018859054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-chorros-restaurant",
      "poi_latitude": "39.0429586",
      "poi_longitude": "-77.0515163",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-933-1066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk0A7ZAPPt4kRLsxne5cM4Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d73d2606-4c50-47f0-9153-1268db2b11c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Frank's Burgers",
      "poi_type": "Restaurants",
      "poi_address": "11230 Grandview Ave Suit 1, Silver Spring, MD 20902, USA",
      "poi_short_description": "Casual, locally owned eatery specializing in burgers, chicken sandwiches and milkshakes made from fresh ingredients.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-2e89-7729-b3bc-1c52e5201435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-2e89-7729-b3bc-1c52e5201435",
        "storage_key": "property/6767906449166326/019fce01-2e89-7729-b3bc-1c52e5201435.webp",
        "width": 847,
        "height": 640
      },
      "poi_business_url": "https://www.franksburgersatwheaton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432458054445684950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franks-burgers",
      "poi_latitude": "39.0391691",
      "poi_longitude": "-77.0527571",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 240-833-8752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeVufdbPt4kR1tjJXAdAqJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4c00cb7-f7be-4450-a99b-5b798d694979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Filippo's Italian Specialties",
      "poi_type": "Restaurants",
      "poi_address": "11224 Triangle Ln, Silver Spring, MD 20902, USA",
      "poi_short_description": "Long-standing Italian deli selling sandwiches & soup, as well as traditional groceries & cold cuts.",
      "poi_long_description": "Long-standing Italian deli selling sandwiches & soup, as well as traditional groceries & cold cuts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3141-763c-a74e-28022ebb0608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3141-763c-a74e-28022ebb0608",
        "storage_key": "property/6767906449166326/019fce01-3141-763c-a74e-28022ebb0608.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://filipposdeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5361598590139896107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "filippos-italian-specialties",
      "poi_latitude": "39.0392634",
      "poi_longitude": "-77.0516102",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-949-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f03d41dcd9c8",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn8t_iRzPt4kRKxGGwYI5aEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cbae51ca-82d0-4a35-ad9b-5f085999e2c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Pupuseria La Familiar",
      "poi_type": "Restaurants",
      "poi_address": "11324 Fern St, Wheaton, MD 20902, USA",
      "poi_short_description": "Pupusería offering familiar dishes such as tamales in a family-friendly setting that evokes El Salvador.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-31dc-731c-9705-8392aec4d7d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-31dc-731c-9705-8392aec4d7d3",
        "storage_key": "property/6767906449166326/019fce01-31dc-731c-9705-8392aec4d7d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pupuserialafamiliar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8779409218028920417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pupuseria-la-familiar",
      "poi_latitude": "39.0410207",
      "poi_longitude": "-77.0496228",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 240-669-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTSFSxvPt4kRYV5nIiu61nk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de3f941a-40a5-407c-b22a-b0afd56812ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Jollibee",
      "poi_type": "Restaurants",
      "poi_address": "2800 University Blvd W, Wheaton-Glenmont, MD 20902, USA",
      "poi_short_description": "Popular Philippines-based chain globally known for its famed fried chicken, spaghetti & burgers.",
      "poi_long_description": "Popular Philippines-based chain globally known for its famed fried chicken, spaghetti & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3296-7358-bbbe-6cd43dd36d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3296-7358-bbbe-6cd43dd36d53",
        "storage_key": "property/6767906449166326/019fce01-3296-7358-bbbe-6cd43dd36d53.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.jollibeefoods.com/usa/md/wheaton/2800-university-blvd-w?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=3060",
      "poi_directions_map_url": "https://maps.google.com/?cid=7304741313596710648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jollibee",
      "poi_latitude": "39.0384506",
      "poi_longitude": "-77.057076",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 240-657-9840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_xu7HzPt4kR-F4NxYWnX2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b4c427d-0ece-4c99-a869-6cf0b3833ffd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Red Ribbon Bakeshop",
      "poi_type": "Restaurants",
      "poi_address": "2501 University Blvd W, Silver Spring, MD 20902, USA",
      "poi_short_description": "Chain of Filipino bakeries selling cakes, sweets & pastries, some with savory fillings.",
      "poi_long_description": "Chain of Filipino bakeries selling cakes, sweets & pastries, some with savory fillings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-359b-7243-9b5f-0e2de5c0ba6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-359b-7243-9b5f-0e2de5c0ba6c",
        "storage_key": "property/6767906449166326/019fce01-359b-7243-9b5f-0e2de5c0ba6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.redribbonbakeshop.com/md/silver-spring/2501-university-blvd-w?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=2507",
      "poi_directions_map_url": "https://maps.google.com/?cid=15849913713096047189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-ribbon-bakeshop",
      "poi_latitude": "39.041645",
      "poi_longitude": "-77.052106",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 240-290-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSi4M7DPt4kRVbqurYs09ts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d433de19-e204-4bf7-bf28-442701a7c99c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "AZUCAR RESTAURANT",
      "poi_type": "Restaurants",
      "poi_address": "14418 Layhill Rd, Layhill, MD 20906, USA",
      "poi_short_description": "Lively neighborhood restaurant serving up Mexican & Pan-Latin dishes in colorful quarters.",
      "poi_long_description": "Lively neighborhood restaurant serving up Mexican & Pan-Latin dishes in colorful quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3845-73a0-94ca-58088bea2fb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3845-73a0-94ca-58088bea2fb9",
        "storage_key": "property/6767906449166326/019fce01-3845-73a0-94ca-58088bea2fb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://azucarrestaurantmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11104274331358310810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azucar-restaurant",
      "poi_latitude": "39.092834",
      "poi_longitude": "-77.04620969999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-438-3293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c473-75a4-9698-fb256760c08e",
        "storage_key": "property/6767906449166326/019d0268-c473-75a4-9698-fb256760c08e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7n7-NfPt4kRmrEZ4atOGpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0343883f-a0ce-4079-adb9-adcbc4065144",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 Randolph Rd Unit A, Wheaton, MD 20902, USA",
      "poi_short_description": "Grocery store chain for produce, seafood, meats and baked goods, plus some household goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3883-7439-8c91-50864a6c4551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3883-7439-8c91-50864a6c4551",
        "storage_key": "property/6767906449166326/019fce01-3883-7439-8c91-50864a6c4551.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lidl.com/stores/US08035",
      "poi_directions_map_url": "https://maps.google.com/?cid=10668576567426937753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "39.0603547",
      "poi_longitude": "-77.0471067",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f58d1df6ba82",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8q-0rPPt4kRmfOJEN1lDpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ddb30e40-8ec0-47cf-aedb-78fb5e27d8e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "International Market Inc",
      "poi_type": "Shopping & Retail",
      "poi_address": "#F, 12335 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3967-75ed-bbe7-386b138cbe0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3967-75ed-bbe7-386b138cbe0a",
        "storage_key": "property/6767906449166326/019fce01-3967-75ed-bbe7-386b138cbe0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://francomeer.wixsite.com/internationalmarket",
      "poi_directions_map_url": "https://maps.google.com/?cid=12593038523899198711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "international-market-inc",
      "poi_latitude": "39.06054830000001",
      "poi_longitude": "-77.0486614",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-949-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f58d1df6ba82",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWgTea7Pt4kR9zzSE9F1w64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a30e749-ac04-457a-8c60-8f8023f79dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "12359 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3c15-708e-aa4e-626eb622ee80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3c15-708e-aa4e-626eb622ee80",
        "storage_key": "property/6767906449166326/019fce01-3c15-708e-aa4e-626eb622ee80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/silver-spring-md-pharmacies/12359-georgia-avenue-silver-spring-md-20906/storeid=1459?WT.mc_id=LS_GOOGLE_RX_1459",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256367725224423656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.0610498",
      "poi_longitude": "-77.04974519999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-942-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c831-74dd-a888-0ab4e4f12639",
        "storage_key": "property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7RhEK7Pt4kR6HDUvphe8kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1187d38c-47eb-47d1-9f6b-b8bbb607de1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Staples",
      "poi_type": "Shopping & Retail",
      "poi_address": "12389 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_long_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3f2b-7431-8b8f-1ca6692af435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3f2b-7431-8b8f-1ca6692af435",
        "storage_key": "property/6767906449166326/019fce01-3f2b-7431-8b8f-1ca6692af435.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.staples.com/md/silver-spring/12389-georgia-ave?cmpid=st_ll_goo&cid=LS:RETAIL:G&utm_source=google&utm_medium=organic&utm_campaign=Google_Business_Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16630242018752325441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staples",
      "poi_latitude": "39.0611014",
      "poi_longitude": "-77.0502549",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-949-6501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f03d41dcd9c8",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQcIEea7Pt4kRQeeBWAF9yuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_edd6c8e9-446f-4896-aeff-05749400c458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2223 Bel Pre Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3f45-75ce-90b4-a6372c53a04c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3f45-75ce-90b4-a6372c53a04c",
        "storage_key": "property/6767906449166326/019fce01-3f45-75ce-90b4-a6372c53a04c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/md/silver-spring/2223-bel-pre-road?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=584000333192454432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.0920253",
      "poi_longitude": "-77.0471247",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f58d1df6ba82",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYti_ijOt4kRIGGleDXJGgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a4f19d74-eea0-433c-8ccc-423a5e2b22ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "H Mart Wheaton",
      "poi_type": "Shopping & Retail",
      "poi_address": "12015 Georgia Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3fbb-7324-a21b-ee3eba9556ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3fbb-7324-a21b-ee3eba9556ae",
        "storage_key": "property/6767906449166326/019fce01-3fbb-7324-a21b-ee3eba9556ae.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.hmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12458901193688962225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-mart-wheaton",
      "poi_latitude": "39.0523537",
      "poi_longitude": "-77.0495875",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-942-5071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f58d1df6ba82",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1W4h8KnPt4kRsVSFJaDo5qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_963fee72-7e71-4a62-accb-99357f0abd7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Lotte Plaza Market - Silver Spring",
      "poi_type": "Shopping & Retail",
      "poi_address": "13625 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "Asian market chain stocking groceries & produce, plus Japanese, Korean & Chinese prepared foods.",
      "poi_long_description": "Asian market chain stocking groceries & produce, plus Japanese, Korean & Chinese prepared foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-428f-762f-87f8-6c573529c5c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-428f-762f-87f8-6c573529c5c9",
        "storage_key": "property/6767906449166326/019fce01-428f-762f-87f8-6c573529c5c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lotteplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6558721651274883984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lotte-plaza-market---silver-spring",
      "poi_latitude": "39.0799493",
      "poi_longitude": "-77.07155279999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 301-962-3355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f58d1df6ba82",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f58d1df6ba82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YBA2TvOt4kRkCPnnJdCBVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f68b494-dde4-44f7-a7c2-cd8d4ea39436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "12331 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "Faded strip mall with eateries and shops, plus a grocery store and a bank.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4550-7139-80df-c955c9b5d330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4550-7139-80df-c955c9b5d330",
        "storage_key": "property/6767906449166326/019fce01-4550-7139-80df-c955c9b5d330.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/3RscocC",
      "poi_directions_map_url": "https://maps.google.com/?cid=9040750627745637105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont-shopping-center",
      "poi_latitude": "39.0593678",
      "poi_longitude": "-77.0499768",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f03d41dcd9c8",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ-yqT67Pt4kR8SKrxcsyd30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_255bc0cb-9fe2-4634-b0bc-a90d783440bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "12029 Georgia Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4572-7468-a4d6-5e6b1e1a6fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4572-7468-a4d6-5e6b1e1a6fcd",
        "storage_key": "property/6767906449166326/019fce01-4572-7468-a4d6-5e6b1e1a6fcd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/md/wheaton/12029-georgia-avenue?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5286432831023194117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.0527288",
      "poi_longitude": "-77.0497867",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 240-621-1908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f03d41dcd9c8",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW0sCH6rPt4kRBaAZrqYuXUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c7561457-91b8-4707-a2a1-d26edba704a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenallan Elementary School",
      "poi_type": "Education",
      "poi_address": "12520 Heurich Rd, Silver Spring, MD 20902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-46b3-711e-a6fd-f643af9c9023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-46b3-711e-a6fd-f643af9c9023",
        "storage_key": "property/6767906449166326/019fce01-46b3-711e-a6fd-f643af9c9023.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.montgomeryschoolsmd.org/schools/glenallanes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7337603267884202408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenallan-elementary-school",
      "poi_latitude": "39.06125309999999",
      "poi_longitude": "-77.0416242",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 240-740-0760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwqF07rPt4kRqLn7vEtn1GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63104804-dde5-40a0-aa2d-3cc333d43488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "John F. Kennedy High School",
      "poi_type": "Education",
      "poi_address": "1901 Randolph Rd, Wheaton, MD 20902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-490b-74eb-aaa5-23d8a42de0a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-490b-74eb-aaa5-23d8a42de0a9",
        "storage_key": "property/6767906449166326/019fce01-490b-74eb-aaa5-23d8a42de0a9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.montgomeryschoolsmd.org/schools/kennedyhs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10587948350356065940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-f-kennedy-high-school",
      "poi_latitude": "39.0658044",
      "poi_longitude": "-77.0389955",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 240-740-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX9w5qL7Pt4kRlA4oY-3y75I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b6086a07-09cb-46d8-8dc2-60211b459637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Argyle Middle School",
      "poi_type": "Education",
      "poi_address": "2400 Bel Pre Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4bbc-752f-8876-f85124a2f969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4bbc-752f-8876-f85124a2f969",
        "storage_key": "property/6767906449166326/019fce01-4bbc-752f-8876-f85124a2f969.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.montgomeryschoolsmd.org/schools/argylems/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17893383586693962868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argyle-middle-school",
      "poi_latitude": "39.0896616",
      "poi_longitude": "-77.04883819999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 240-740-6370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJubPNldbPt4kRdNyyopERUvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afa881cf-f345-4c80-9982-87df58a1ea3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Wheaton High School",
      "poi_type": "Education",
      "poi_address": "12401 Dalewood Dr, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4c1a-757d-94a5-495fb3380ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4c1a-757d-94a5-495fb3380ecf",
        "storage_key": "property/6767906449166326/019fce01-4c1a-757d-94a5-495fb3380ecf.webp",
        "width": 1280,
        "height": 1020
      },
      "poi_business_url": "http://www.montgomeryschoolsmd.org/schools/wheatonhs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9311046186742275663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheaton-high-school",
      "poi_latitude": "39.0599034",
      "poi_longitude": "-77.0672593",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-321-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56gw9VDOt4kRT14HwCx7N4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e67de69-296b-46f7-8780-87094ced1537",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Barrie School",
      "poi_type": "Education",
      "poi_address": "13500 Layhill Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4da5-70d8-bcb3-eca17acd28a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4da5-70d8-bcb3-eca17acd28a6",
        "storage_key": "property/6767906449166326/019fce01-4da5-70d8-bcb3-eca17acd28a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.barrie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278066244797393171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrie-school",
      "poi_latitude": "39.0777181",
      "poi_longitude": "-77.04899979999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-576-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyy9Jtc7Pt4kRE-ncmTJ0ZKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0cb3ea3b-c89a-4c55-8aa6-3c0cb8204214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Montgomery College - East County Education Center",
      "poi_type": "Education",
      "poi_address": "2221 Broadbirch Dr, Silver Spring, MD 20904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-4ef8-712d-9b19-55d0e2693ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-4ef8-712d-9b19-55d0e2693ae2",
        "storage_key": "property/6767906449166326/019fce01-4ef8-712d-9b19-55d0e2693ae2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.montgomerycollege.edu/about-mc/campuses-and-locations/east-county-education-center/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6418863571818889002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-college---east-county-education-center",
      "poi_latitude": "39.0551716",
      "poi_longitude": "-76.9628693",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 240-567-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJifAPPADFt4kRKr_182hiFFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cefb6564-315e-421c-bca8-a689d364e7b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Primrose School of Silver Spring at Layhill",
      "poi_type": "Education",
      "poi_address": "2020 Queensguard Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-51fb-727d-b3dd-cdab86d1d64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-51fb-727d-b3dd-cdab86d1d64d",
        "storage_key": "property/6767906449166326/019fce01-51fb-727d-b3dd-cdab86d1d64d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/silver-spring/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654487418628982635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-silver-spring-at-layhill",
      "poi_latitude": "39.0875508",
      "poi_longitude": "-77.0441265",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-278-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSTk70fPt4kRa8ev3Qx9WVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e52edcb-76af-4e6a-8245-3ee59fb456db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Kreative Kidz Children's Center",
      "poi_type": "Education",
      "poi_address": "14500 Layhill Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-5267-71cf-8b4d-dfa903631d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-5267-71cf-8b4d-dfa903631d3d",
        "storage_key": "property/6767906449166326/019fce01-5267-71cf-8b4d-dfa903631d3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kreativekidzacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11113006103541538288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kreative-kidz-childrens-center",
      "poi_latitude": "39.094728",
      "poi_longitude": "-77.04561149999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-598-5432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ0VKnCjQt4kR8F1XBCxUOZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bbf22c56-034e-4f73-bd84-8f220079e722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Montgomery College Takoma Park/Silver Spring Campus",
      "poi_type": "Education",
      "poi_address": "7600 Takoma Ave #4141, Takoma Park, MD 20912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-54b6-71f1-b5da-f32dd39746ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-54b6-71f1-b5da-f32dd39746ae",
        "storage_key": "property/6767906449166326/019fce01-54b6-71f1-b5da-f32dd39746ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.montgomerycollege.edu/about-mc/campuses-and-locations/takoma-park-silver-spring-campus/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12245799467555120254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-college-takoma-parksilver-spring-campus",
      "poi_latitude": "38.98514979999999",
      "poi_longitude": "-77.0226024",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 240-567-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLRDsMZbIt4kRfmRKFrzR8ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8f2d9aa0-3ddb-4945-9f63-0ee0b557ed06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "AFI Silver Theatre and Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "8633 Colesville Rd, Silver Spring, MD 20910, USA",
      "poi_short_description": "Historic cinema hosts a series of film festivals as well as new & classic movies plus documentaries.",
      "poi_long_description": "Historic cinema hosts a series of film festivals as well as new & classic movies plus documentaries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-5575-7468-8fdc-b754a5e4ac0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-5575-7468-8fdc-b754a5e4ac0e",
        "storage_key": "property/6767906449166326/019fce01-5575-7468-8fdc-b754a5e4ac0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://afi.com/Silver",
      "poi_directions_map_url": "https://maps.google.com/?cid=3615525462115548906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afi-silver-theatre-and-cultural-center",
      "poi_latitude": "38.9965658",
      "poi_longitude": "-77.0274675",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 301-495-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c840-760d-842e-ba252f30e6b2",
        "storage_key": "property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUT7YH7rIt4kR6v7GfUDtLDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8407c82d-7071-4786-bc6e-7f420f89fbc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "The Fillmore Silver Spring",
      "poi_type": "Entertainment",
      "poi_address": "8656 Colesville Rd, Silver Spring, MD 20910, USA",
      "poi_short_description": "Big-name artists & national acts star at this spacious music venue with several bars & ornate decor.",
      "poi_long_description": "Big-name artists & national acts star at this spacious music venue with several bars & ornate decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-589f-723e-bfd8-4512571ef101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-589f-723e-bfd8-4512571ef101",
        "storage_key": "property/6767906449166326/019fce01-589f-723e-bfd8-4512571ef101.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fillmoresilverspring.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12046486291342551469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fillmore-silver-spring",
      "poi_latitude": "38.997449",
      "poi_longitude": "-77.027579",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 301-960-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIxKP_rnIt4kRrekV-3S3Lac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44adb75b-8d0a-4f93-9640-f08f1ea9b6a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Regal Majestic",
      "poi_type": "Entertainment",
      "poi_address": "900 Ellsworth Dr, Silver Spring, MD 20910, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-591a-7741-aed8-cb37b9560265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-591a-7741-aed8-cb37b9560265",
        "storage_key": "property/6767906449166326/019fce01-591a-7741-aed8-cb37b9560265.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-majestic-1862?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10114509925640299403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-majestic",
      "poi_latitude": "38.9965426",
      "poi_longitude": "-77.0253851",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c840-760d-842e-ba252f30e6b2",
        "storage_key": "property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJH-fBZbrIt4kRi-PzOjD1XYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_29d8a3a9-90fc-49b1-9efe-c471f6273731",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "AMC Wheaton Mall 9",
      "poi_type": "Entertainment",
      "poi_address": "11006 Veirs Mill Rd, Wheaton, MD 20902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-5c36-7289-88b0-feef23da7bf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-5c36-7289-88b0-feef23da7bf0",
        "storage_key": "property/6767906449166326/019fce01-5c36-7289-88b0-feef23da7bf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/washington-d-c/amc-wheaton-mall-9?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2427749502108101854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-wheaton-mall-9",
      "poi_latitude": "39.0353243",
      "poi_longitude": "-77.051688",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 240-292-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c840-760d-842e-ba252f30e6b2",
        "storage_key": "property/6767906449166326/019d0268-c840-760d-842e-ba252f30e6b2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzC7vh7Pt4kR3uzINE8ZsSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3105c67b-a3bf-4bff-86f3-8fa1c7f5514c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Brookside Gardens",
      "poi_type": "Entertainment",
      "poi_address": "1800 Glenallan Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Sprawling 50-acre green space with conservatories, water elements, flowers & fruit trees.",
      "poi_long_description": "Sprawling 50-acre green space with conservatories, water elements, flowers & fruit trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-5cc6-7775-aac2-1115108b4226.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-5cc6-7775-aac2-1115108b4226",
        "storage_key": "property/6767906449166326/019fce01-5cc6-7775-aac2-1115108b4226.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brooksidegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4459569348799836804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-gardens",
      "poi_latitude": "39.059552",
      "poi_longitude": "-77.0392758",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-962-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5gDDKPPt4kRhDJv5rGS4z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd13b172-ff8d-401a-8533-28479a96b6ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Brookside Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "1400 Glenallan Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Interpretive center dedicated to flora & fauna with animal exhibits & an outdoor nature play area.",
      "poi_long_description": "Interpretive center dedicated to flora & fauna with animal exhibits & an outdoor nature play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6082-7748-bff5-90354de9d718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6082-7748-bff5-90354de9d718",
        "storage_key": "property/6767906449166326/019fce01-6082-7748-bff5-90354de9d718.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/brookside-nature-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15306099504511213026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-nature-center",
      "poi_latitude": "39.0595899",
      "poi_longitude": "-77.0333223",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-962-1480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0y4DJjPt4kR4l0sd2cwatQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1090844d-99a7-4a1a-bee9-e7a82a425302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "National Capital Trolley Museum",
      "poi_type": "Entertainment",
      "poi_address": "1313 Bonifant Rd, Cloverly, MD 20905, USA",
      "poi_short_description": "Museum featuring classic streetcars from around the world & trolley rides along a 1-mile railway.",
      "poi_long_description": "Museum featuring classic streetcars from around the world & trolley rides along a 1-mile railway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6015-75ee-bac8-62026fd18c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6015-75ee-bac8-62026fd18c60",
        "storage_key": "property/6767906449166326/019fce01-6015-75ee-bac8-62026fd18c60.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://dctrolley.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12829564130781773553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-capital-trolley-museum",
      "poi_latitude": "39.09794249999999",
      "poi_longitude": "-77.0313135",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-384-6352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd37-763d-bf65-1be8cfdd9a91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd37-763d-bf65-1be8cfdd9a91",
        "storage_key": "property/6767906449166326/019d0268-cd37-763d-bf65-1be8cfdd9a91.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyFkyB7Qt4kR8T5XXprEC7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27e824c5-6271-4f4e-bdf0-c8b7819d0ad5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "National Museum of Health and Medicine",
      "poi_type": "Entertainment",
      "poi_address": "2500 Linden Ln, Silver Spring, MD 20910, USA",
      "poi_short_description": "The history of military medicine is detailed in thousands of specimens dating back to the Civil War.",
      "poi_long_description": "The history of military medicine is detailed in thousands of specimens dating back to the Civil War.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6315-74d9-aa38-5e178c085bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6315-74d9-aa38-5e178c085bbf",
        "storage_key": "property/6767906449166326/019fce01-6315-74d9-aa38-5e178c085bbf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://medicalmuseum.health.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13662245761233016377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-museum-of-health-and-medicine",
      "poi_latitude": "39.0087504",
      "poi_longitude": "-77.0531492",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 301-319-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd37-763d-bf65-1be8cfdd9a91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd37-763d-bf65-1be8cfdd9a91",
        "storage_key": "property/6767906449166326/019d0268-cd37-763d-bf65-1be8cfdd9a91.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIcEMLjK4t4kROVZhWCIMmr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_254320ed-9e62-4794-ba68-12d067007dde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glen Echo Park",
      "poi_type": "Entertainment",
      "poi_address": "7300 Macarthur Blvd, Glen Echo, MD 20812, USA",
      "poi_short_description": "Managed by the Partnership for Arts & Culture, this park has kids camps, concerts, art shows & more.",
      "poi_long_description": "Managed by the Partnership for Arts & Culture, this park has kids camps, concerts, art shows & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6471-751f-8ee1-d5bf272db46a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6471-751f-8ee1-d5bf272db46a",
        "storage_key": "property/6767906449166326/019fce01-6471-751f-8ee1-d5bf272db46a.webp",
        "width": 1280,
        "height": 796
      },
      "poi_business_url": "https://glenechopark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9916988207111644158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glen-echo-park",
      "poi_latitude": "38.9664221",
      "poi_longitude": "-77.13815300000002",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 301-634-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Uwo9lrKt4kR_qOgXjs4oIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84c49629-33aa-452c-a24a-a62235fb3371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Round House Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4545 East-West Hwy, Bethesda, MD 20814, USA",
      "poi_short_description": "Venue for a local theater company known for plays, musicals & educational arts programming.",
      "poi_long_description": "Venue for a local theater company known for plays, musicals & educational arts programming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-673f-76a3-93e6-e7e06763ad0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-673f-76a3-93e6-e7e06763ad0a",
        "storage_key": "property/6767906449166326/019fce01-673f-76a3-93e6-e7e06763ad0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roundhousetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5936932819264134620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "round-house-theatre",
      "poi_latitude": "38.9854045",
      "poi_longitude": "-77.0925961",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 240-644-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7LYOGXJt4kR3N2Yo_E4ZFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_13bb1fdf-5af9-4fe7-bbd5-8aa9645c2ed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Holy Cross Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 Forest Glen Rd, Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6766-72cb-ba01-4ed7beaabce7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6766-72cb-ba01-4ed7beaabce7",
        "storage_key": "property/6767906449166326/019fce01-6766-72cb-ba01-4ed7beaabce7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4198465176336525575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-hospital",
      "poi_latitude": "39.0146998",
      "poi_longitude": "-77.0350306",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 301-754-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOeThEjbPt4kRB-liXdXxQzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_046f3cc0-3620-4caf-842a-aa146e05b143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Adventist HealthCare White Oak Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11890 Healing Wy, Silver Spring, MD 20904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-698d-7429-a359-1767f2ffeca7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-698d-7429-a359-1767f2ffeca7",
        "storage_key": "property/6767906449166326/019fce01-698d-7429-a359-1767f2ffeca7.webp",
        "width": 740,
        "height": 430
      },
      "poi_business_url": "https://www.adventisthealthcare.com/locations/profile/white-oak-medical-center/?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12481725269602029187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventist-healthcare-white-oak-medical-center",
      "poi_latitude": "39.0493777",
      "poi_longitude": "-76.9574871",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 240-637-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05suE3PFt4kRg06lbgD_N60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1436f76f-0c7b-4248-bd10-df5a55405df7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Fast Track Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "13428 New Hampshire Ave, Silver Spring, MD 20904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6afa-72ba-b2de-56468e0ff2ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6afa-72ba-b2de-56468e0ff2ca",
        "storage_key": "property/6767906449166326/019fce01-6afa-72ba-b2de-56468e0ff2ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fastrackmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13197179812334708233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fast-track-urgent-care",
      "poi_latitude": "39.0768699",
      "poi_longitude": "-77.0022967",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-384-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadzffFrFt4kRCaYqHx7NJbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0f65b085-e858-4cc1-ae37-75c5a956a418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12359 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-3c15-708e-aa4e-626eb622ee80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-3c15-708e-aa4e-626eb622ee80",
        "storage_key": "property/6767906449166326/019fce01-3c15-708e-aa4e-626eb622ee80.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/silver-spring-md-pharmacies/12359-georgia-avenue-silver-spring-md-20906/storeid=1459?WT.mc_id=LS_GOOGLE_RX_1459",
      "poi_directions_map_url": "https://maps.google.com/?cid=5256367725224423656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.0610498",
      "poi_longitude": "-77.04974519999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-942-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c831-74dd-a888-0ab4e4f12639",
        "storage_key": "property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7RhEK7Pt4kR6HDUvphe8kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95ec1f7d-0db7-4a63-b45e-a45cc40dd9ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13870 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6d8a-74b2-b99b-1adfdb646b6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6d8a-74b2-b99b-1adfdb646b6d",
        "storage_key": "property/6767906449166326/019fce01-6d8a-74b2-b99b-1adfdb646b6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13870+georgia+ave-silver+spring-md-20906/id=19339",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797666498717630981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.0818358",
      "poi_longitude": "-77.0780391",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-871-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c831-74dd-a888-0ab4e4f12639",
        "storage_key": "property/6767906449166326/019d0268-c831-74dd-a888-0ab4e4f12639.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs-2dkinPt4kRBUIz23gE2ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_38899443-0d30-45d3-a573-c43e7e097c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1290 East-West Hwy, Silver Spring, MD 20910, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6e38-706f-a064-a0ba68b8f8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6e38-706f-a064-a0ba68b8f8bd",
        "storage_key": "property/6767906449166326/019fce01-6e38-706f-a064-a0ba68b8f8bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/silver-spring-md-pharmacies/1290-east-west-highway-silver-spring-md-20910/storeid=1477?WT.mc_id=LS_GOOGLE_FS_1477",
      "poi_directions_map_url": "https://maps.google.com/?cid=4619053879958310967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.9924182",
      "poi_longitude": "-77.0319559",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 301-588-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVbn4Rr_It4kRNxBO8QctGkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f14fe25d-8cb4-45fb-aa4a-fc38e3888090",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11130 New Hampshire Ave, Silver Spring, MD 20904, USA",
      "poi_short_description": "Chain gym for members featuring equipment, massage chairs, and tanning and spa services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6f4b-72dc-a7aa-5445bcc1051b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6f4b-72dc-a7aa-5445bcc1051b",
        "storage_key": "property/6767906449166326/019fce01-6f4b-72dc-a7aa-5445bcc1051b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/silver-spring-md?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5131235716766618096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.0380096",
      "poi_longitude": "-76.9910871",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 240-670-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtYQgHpnFt4kR8NGrrLLPNUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc0b58a6-91db-4504-9fa6-a6a17707665d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "956 Thayer Ave, Silver Spring, MD 20910, USA",
      "poi_short_description": "Pilates studio specializing in reformer fusion classes and workouts for all skill levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-711d-709c-a16e-21e50bdf7e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-711d-709c-a16e-21e50bdf7e33",
        "storage_key": "property/6767906449166326/019fce01-711d-709c-a16e-21e50bdf7e33.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/silverspring/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614959210520119512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "38.9928732",
      "poi_longitude": "-77.025789",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 240-842-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwiZqevJt4kR2Ai0_9yfMKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96e666ed-a3f3-4c53-9878-d14a4d49283a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Westfield Wheaton",
      "poi_type": "Health and Wellness",
      "poi_address": "11160 Veirs Mill Rd, Wheaton, MD 20902, USA",
      "poi_short_description": "Indoor mall featuring a wide variety of shopping & dining options, plus a kiddie play area & train.",
      "poi_long_description": "Indoor mall featuring a wide variety of shopping & dining options, plus a kiddie play area & train.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7345-733d-9aa4-765798dde2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7345-733d-9aa4-765798dde2d6",
        "storage_key": "property/6767906449166326/019fce01-7345-733d-9aa4-765798dde2d6.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.westfield.com/united-states/wheaton?utm_source=google&utm_medium=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=7869735909027918992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westfield-wheaton",
      "poi_latitude": "39.0366593",
      "poi_longitude": "-77.0550789",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-945-4122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c46f-747f-9871-f03d41dcd9c8",
        "storage_key": "property/6767906449166326/019d0268-c46f-747f-9871-f03d41dcd9c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ92uXgh3Pt4kRkLS-FR3rNm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d227edc7-0405-4475-bfe5-7fb914abfa84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont Greenway Urban Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12400 Georgia Ave, Aspen Hill, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7526-7748-8998-3529d8373d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7526-7748-8998-3529d8373d5e",
        "storage_key": "property/6767906449166326/019fce01-7526-7748-8998-3529d8373d5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/glenmont-greenway-urban-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12652585994889029232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont-greenway-urban-park",
      "poi_latitude": "39.061639",
      "poi_longitude": "-77.0541787",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6_SnK7Pt4kRcGZxE-0Dl68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3fa52d9e-6dac-4a7a-9b0f-739732e1e3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenfield Local Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12800 Layhill Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "Local park offering tennis courts and a soccer field as well as playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7672-745e-9fa0-24f256c23ad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7672-745e-9fa0-24f256c23ad0",
        "storage_key": "property/6767906449166326/019fce01-7672-745e-9fa0-24f256c23ad0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://montgomeryparks.org/parks-and-trails/glenfield-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2368221368512373120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenfield-local-park",
      "poi_latitude": "39.0669974",
      "poi_longitude": "-77.048171",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Zv0KrfPt4kRgGGri8mc3SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a4a95b6-8e9b-477e-845d-f06a88f6eb3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Saddlebrook Local Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12751 Layhill Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-78c6-729f-ac80-c49e90f72585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-78c6-729f-ac80-c49e90f72585",
        "storage_key": "property/6767906449166326/019fce01-78c6-729f-ac80-c49e90f72585.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://montgomeryparks.org/parks-and-trails/saddlebrook-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12338389070740220347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saddlebrook-local-park",
      "poi_latitude": "39.0639573",
      "poi_longitude": "-77.0460429",
      "poi_miles_from_property": "463 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Vx7hbDPt4kRu2kI_nzDOqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aeaeea5e-bc96-4b51-b1d1-3c970f597473",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont Local Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3201 Randolph Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7a2d-75ae-a6a3-f62ba60c822f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7a2d-75ae-a6a3-f62ba60c822f",
        "storage_key": "property/6767906449166326/019fce01-7a2d-75ae-a6a3-f62ba60c822f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/glenmont-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4536322282038020362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont-local-park",
      "poi_latitude": "39.0594124",
      "poi_longitude": "-77.0644275",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UdWZFHOt4kRCsmQvxRB9D4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_05a1c1a7-5628-4262-8b0d-5fbf29d42e34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Valleywood Neighborhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13115 Valleywood Dr, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7c52-700c-b3e6-4fa2a886fd64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7c52-700c-b3e6-4fa2a886fd64",
        "storage_key": "property/6767906449166326/019fce01-7c52-700c-b3e6-4fa2a886fd64.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://montgomeryparks.org/parks-and-trails/valleywood-neighborhood-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13909723518343540176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valleywood-neighborhood-park",
      "poi_latitude": "39.071498",
      "poi_longitude": "-77.0691506",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYchWsuzPt4kR0G3D0tdDCcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb0b5cf9-5c04-473c-9c09-7bc1d54fc264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Georgian Forest Local Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2720 Silverdale Dr, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-7d54-74d4-811e-5d30a8f4a86b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-7d54-74d4-811e-5d30a8f4a86b",
        "storage_key": "property/6767906449166326/019fce01-7d54-74d4-811e-5d30a8f4a86b.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.montgomeryparks.org/parks-and-trails/georgian-forest-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7810585939342737264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgian-forest-local-park",
      "poi_latitude": "39.0738567",
      "poi_longitude": "-77.05935",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJERMLcjXOt4kRcD8vkofGZGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_827143af-94d3-4963-b2f2-27b39000613e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Brookside Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1800 Glenallan Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Sprawling 50-acre green space with conservatories, water elements, flowers & fruit trees.",
      "poi_long_description": "Sprawling 50-acre green space with conservatories, water elements, flowers & fruit trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-80a2-7333-ae63-af5c4bd161c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-80a2-7333-ae63-af5c4bd161c3",
        "storage_key": "property/6767906449166326/019fce01-80a2-7333-ae63-af5c4bd161c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brooksidegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4459569348799836804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-gardens",
      "poi_latitude": "39.059552",
      "poi_longitude": "-77.0392758",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-962-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5gDDKPPt4kRhDJv5rGS4z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cbd96321-b005-487f-b163-15b54b4fc0cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Wheaton Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 Shorefield Rd, Silver Spring, MD 20902, USA",
      "poi_short_description": "County park has playground, picnic areas, train, carousel, nature center, tennis, trails & stables.",
      "poi_long_description": "County park has playground, picnic areas, train, carousel, nature center, tennis, trails & stables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-821a-7508-9c9e-6f4ffcc52124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-821a-7508-9c9e-6f4ffcc52124",
        "storage_key": "property/6767906449166326/019fce01-821a-7508-9c9e-6f4ffcc52124.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.montgomeryparks.org/parks-and-trails/wheaton-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5271344336900742424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheaton-regional-park",
      "poi_latitude": "39.051915",
      "poi_longitude": "-77.0430863",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYw8R4ADPt4kRGF284b6TJ0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_119bee3a-9ab7-4ff6-8061-a10510cdf932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Brookside Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Glenallan Ave, Wheaton, MD 20902, USA",
      "poi_short_description": "Interpretive center dedicated to flora & fauna with animal exhibits & an outdoor nature play area.",
      "poi_long_description": "Interpretive center dedicated to flora & fauna with animal exhibits & an outdoor nature play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6082-7748-bff5-90354de9d718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6082-7748-bff5-90354de9d718",
        "storage_key": "property/6767906449166326/019fce01-6082-7748-bff5-90354de9d718.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/brookside-nature-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15306099504511213026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-nature-center",
      "poi_latitude": "39.0595899",
      "poi_longitude": "-77.0333223",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-962-1480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0y4DJjPt4kR4l0sd2cwatQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8340241-ba11-42f5-a1a2-cc230d636808",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Wheaton Local Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11729 Georgia Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "Kids' playground featuring swings, slides and interactive musical features and instruments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-8320-77e8-8320-5c6ab5398495.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-8320-77e8-8320-5c6ab5398495",
        "storage_key": "property/6767906449166326/019fce01-8320-77e8-8320-5c6ab5398495.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/wheaton-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11739643894739883784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheaton-local-park",
      "poi_latitude": "39.0491454",
      "poi_longitude": "-77.05127159999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG3flLVXPt4kRCNeNR-yX66I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_544a917c-757f-4ac1-8e75-5b8d596d1f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont",
      "poi_type": "Transportation & Transit",
      "poi_address": "Glenmont, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-841b-77b1-bcf8-17baff71cfad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-841b-77b1-bcf8-17baff71cfad",
        "storage_key": "property/6767906449166326/019fce01-841b-77b1-bcf8-17baff71cfad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wmata.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7521455411913196569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont",
      "poi_latitude": "39.0619058",
      "poi_longitude": "-77.0537296",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpaRVf63Pt4kRGYQGxdiTYWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ebea6aaf-9b05-45d5-8129-d45f19999ca6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont Metro Kiss & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "12501 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-87f0-733b-b1fa-b03eb0efffe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-87f0-733b-b1fa-b03eb0efffe3",
        "storage_key": "property/6767906449166326/019fce01-87f0-733b-b1fa-b03eb0efffe3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15019055176646536770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont-metro-kiss--ride",
      "poi_latitude": "39.062816",
      "poi_longitude": "-77.0530254",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cf1f-7027-a69a-0a652371a07a",
        "storage_key": "property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJK89RZLLPt4kRQi4C2htnbtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_56f81861-564f-4ccb-b186-b66731b70f04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont",
      "poi_type": "Transportation & Transit",
      "poi_address": "12501 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-8957-71e1-8812-4ba028b2505d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-8957-71e1-8812-4ba028b2505d",
        "storage_key": "property/6767906449166326/019fce01-8957-71e1-8812-4ba028b2505d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wmata.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4295829000074888808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont",
      "poi_latitude": "39.06273849999999",
      "poi_longitude": "-77.0515892",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 202-637-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cf1f-7027-a69a-0a652371a07a",
        "storage_key": "property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZSGEbLPt4kRaAZJHbfZnTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c3a62fe1-e398-4945-a4f0-bbf0bf0a65ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Glenmont",
      "poi_type": "Transportation & Transit",
      "poi_address": "12501 Georgia Ave, Silver Spring, MD 20906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-89b2-7348-b555-c9c430319794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-89b2-7348-b555-c9c430319794",
        "storage_key": "property/6767906449166326/019fce01-89b2-7348-b555-c9c430319794.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wmata.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4295829000074888808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenmont",
      "poi_latitude": "39.06273849999999",
      "poi_longitude": "-77.0515892",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 202-637-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cf1f-7027-a69a-0a652371a07a",
        "storage_key": "property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZSGEbLPt4kRaAZJHbfZnTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cdc2ec35-3d76-4d43-98e9-5364d5a6f4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "East Norbeck Local Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "3131 Norbeck Rd, Silver Spring, MD 20906, USA",
      "poi_short_description": "Neighborhood park featuring baseball and soccer fields, tennis and basketball courts, and playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-8be6-7188-a71b-d235a2b2dbe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-8be6-7188-a71b-d235a2b2dbe8",
        "storage_key": "property/6767906449166326/019fce01-8be6-7188-a71b-d235a2b2dbe8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montgomeryparks.org/parks-and-trails/east-norbeck-local-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4399910509372499647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-norbeck-local-park",
      "poi_latitude": "39.1128287",
      "poi_longitude": "-77.0639709",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-495-2595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd35-749d-9b7c-9e532a878147",
        "storage_key": "property/6767906449166326/019d0268-cd35-749d-9b7c-9e532a878147.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfr9rsnRt4kRv-an6kufDz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a62f25c3-a9b0-4dfe-a37b-29bf1ae0e386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Briggs Chaney Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Gateshead Manor Way, Silver Spring, MD 20904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-8e94-725b-8c84-c8ac065f2374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-8e94-725b-8c84-c8ac065f2374",
        "storage_key": "property/6767906449166326/019fce01-8e94-725b-8c84-c8ac065f2374.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046148560027343524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briggs-chaney-park--ride",
      "poi_latitude": "39.0779876",
      "poi_longitude": "-76.9419021",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cf1f-7027-a69a-0a652371a07a",
        "storage_key": "property/6767906449166326/019d0268-cf1f-7027-a69a-0a652371a07a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9dA88rEt4kRpFpzKnypqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a57e0e9-677b-417b-a39a-7f941e8ffc4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Silver Spring Transit Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-8f78-75bf-8609-4c4bd0358279.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-8f78-75bf-8609-4c4bd0358279",
        "storage_key": "property/6767906449166326/019fce01-8f78-75bf-8609-4c4bd0358279.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18009950932848850674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-spring-transit-center-station",
      "poi_latitude": "38.994042",
      "poi_longitude": "-77.030029",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-d165-71e8-9884-291c8363451f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-d165-71e8-9884-291c8363451f",
        "storage_key": "property/6767906449166326/019d0268-d165-71e8-9884-291c8363451f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89k5PbnIt4kR8rar3vMy8Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27108f18-7cea-4437-96e8-e0ca503bc955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Silver Spring",
      "poi_type": "Transportation & Transit",
      "poi_address": "8400 Colesville Rd, Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-9093-7399-9cb0-d31e97a03c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-9093-7399-9cb0-d31e97a03c40",
        "storage_key": "property/6767906449166326/019fce01-9093-7399-9cb0-d31e97a03c40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wmata.com/rider-guide/stations/silver-spring.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=13842771064189348208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-spring",
      "poi_latitude": "38.99373689999999",
      "poi_longitude": "-77.0312016",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJty8xt7jIt4kRcOkP1PBmG8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_871a32b4-83e7-4ab8-9f37-4b4f77f60e33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Capital Bikeshare: Silver Spring Metro / Colesville Rd & Wayne Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-9361-75df-9fd3-fef2f76dec34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-9361-75df-9fd3-fef2f76dec34",
        "storage_key": "property/6767906449166326/019fce01-9361-75df-9fd3-fef2f76dec34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16087637823856135133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capital-bikeshare-silver-spring-metro--colesville-rd--wayne-ave",
      "poi_latitude": "38.9952564",
      "poi_longitude": "-77.0291242",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04W2CrnIt4kR3UsVZl3FQt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36d80677-f33c-411f-add1-bef3c8711cc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Wheaton",
      "poi_type": "Transportation & Transit",
      "poi_address": "11171 Georgia Ave, Silver Spring, MD 20902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-95e7-74a9-9ff1-74dea91530c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-95e7-74a9-9ff1-74dea91530c5",
        "storage_key": "property/6767906449166326/019fce01-95e7-74a9-9ff1-74dea91530c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wmata.com/rider-guide/stations/wheaton.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=1536775635887602310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheaton",
      "poi_latitude": "39.038734",
      "poi_longitude": "-77.05027799999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c8dd-733e-98f9-15d656cec608",
        "storage_key": "property/6767906449166326/019d0268-c8dd-733e-98f9-15d656cec608.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6RsfxzPt4kRhjqOdEy5UxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd5e172b-8796-4c2c-bcd6-878aa99d5945",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "FDA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10903 New Hampshire Ave, Silver Spring, MD 20993, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-979b-77e3-8bd7-a0033d7068d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-979b-77e3-8bd7-a0033d7068d0",
        "storage_key": "property/6767906449166326/019fce01-979b-77e3-8bd7-a0033d7068d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fda.gov/about-fda/buildings-and-facilities/white-oak-campus-information",
      "poi_directions_map_url": "https://maps.google.com/?cid=7704287929116871619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fda",
      "poi_latitude": "39.0351",
      "poi_longitude": "-76.9805823",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-463-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-d164-72ce-9c31-05713ffb448e",
        "storage_key": "property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF6jXnqTFt4kRw0tXbg0h62o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0935f9db-8a4e-4f8b-8c7a-3a3d5a95f3e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Adventist HealthCare White Oak Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11890 Healing Wy, Silver Spring, MD 20904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-698d-7429-a359-1767f2ffeca7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-698d-7429-a359-1767f2ffeca7",
        "storage_key": "property/6767906449166326/019fce01-698d-7429-a359-1767f2ffeca7.webp",
        "width": 740,
        "height": 430
      },
      "poi_business_url": "https://www.adventisthealthcare.com/locations/profile/white-oak-medical-center/?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12481725269602029187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventist-healthcare-white-oak-medical-center",
      "poi_latitude": "39.0493777",
      "poi_longitude": "-76.9574871",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 240-637-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05suE3PFt4kRg06lbgD_N60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_740232db-ddda-4e7d-9e6a-010604757af6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Holy Cross Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Forest Glen Rd, Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-6766-72cb-ba01-4ed7beaabce7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-6766-72cb-ba01-4ed7beaabce7",
        "storage_key": "property/6767906449166326/019fce01-6766-72cb-ba01-4ed7beaabce7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4198465176336525575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-hospital",
      "poi_latitude": "39.0146998",
      "poi_longitude": "-77.0350306",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 301-754-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOeThEjbPt4kRB-liXdXxQzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b87d0afa-47a8-457a-ac7d-601e3be6bc7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Montgomery College Takoma Park/Silver Spring Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7600 Takoma Ave #4141, Takoma Park, MD 20912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-54b6-71f1-b5da-f32dd39746ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-54b6-71f1-b5da-f32dd39746ae",
        "storage_key": "property/6767906449166326/019fce01-54b6-71f1-b5da-f32dd39746ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.montgomerycollege.edu/about-mc/campuses-and-locations/takoma-park-silver-spring-campus/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12245799467555120254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-college-takoma-parksilver-spring-campus",
      "poi_latitude": "38.98514979999999",
      "poi_longitude": "-77.0226024",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 240-567-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c83b-71a9-b224-c60e2aae6a18",
        "storage_key": "property/6767906449166326/019d0268-c83b-71a9-b224-c60e2aae6a18.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLRDsMZbIt4kRfmRKFrzR8ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_89d90f2c-0477-48b9-a23d-ed79b937a0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "National Oceanic and Atmospheric Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Silver Spring Metro Center I, 1335 East-West Hwy, Silver Spring, MD 20910, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-97d4-7218-8be6-0487a7556054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-97d4-7218-8be6-0487a7556054",
        "storage_key": "property/6767906449166326/019fce01-97d4-7218-8be6-0487a7556054.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.noaa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16584171117810604972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-oceanic-and-atmospheric-administration",
      "poi_latitude": "38.9923903",
      "poi_longitude": "-77.0305535",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 301-713-6357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-d164-72ce-9c31-05713ffb448e",
        "storage_key": "property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXhVybjIt4kRrNtk08PPJuY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cf67da21-bc2e-42e2-8560-0b604fe87744",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Adventist HealthCare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7600 Carroll Ave, Takoma Park, MD 20912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8951348231049335756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventist-healthcare",
      "poi_latitude": "38.9855208",
      "poi_longitude": "-77.0019252",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 301-891-5651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTRtiBjGt4kRzFOENMqTOXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3200de8d-c04d-4e75-b5ca-1b156ed62c52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "Montgomery County Council Office Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Stella Werner Council Office Building, 100 Maryland Ave, Rockville, MD 20850, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-9b04-769c-a3f4-d302421c163f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-9b04-769c-a3f4-d302421c163f",
        "storage_key": "property/6767906449166326/019fce01-9b04-769c-a3f4-d302421c163f.webp",
        "width": 1280,
        "height": 1048
      },
      "poi_business_url": "http://www.montgomerycountymd.gov/Council",
      "poi_directions_map_url": "https://maps.google.com/?cid=60929612319223595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-council-office-building",
      "poi_latitude": "39.0821209",
      "poi_longitude": "-77.1509363",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 240-777-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-d164-72ce-9c31-05713ffb448e",
        "storage_key": "property/6767906449166326/019d0268-d164-72ce-9c31-05713ffb448e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSl-2wrNt4kRK--W2ih32AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d5c64ccc-e4ee-49a0-b0f2-787f2b401e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "NIH Clinical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10 Center Dr, Bethesda, MD 20892, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-9d3a-763f-a3f3-67498eb44ea5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-9d3a-763f-a3f3-67498eb44ea5",
        "storage_key": "property/6767906449166326/019fce01-9d3a-763f-a3f3-67498eb44ea5.webp",
        "width": 1191,
        "height": 839
      },
      "poi_business_url": "http://clinicalcenter.nih.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18295031345507196360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nih-clinical-center",
      "poi_latitude": "39.0019296",
      "poi_longitude": "-77.1044561",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 301-496-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_TjTWuLLt4kRyN2X1xMC5f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8158cf2-7f36-4c5f-926f-4eb8cb72f458",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "poi_name": "MedStar Montgomery Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18101 Prince Philip Dr, Olney, MD 20832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce01-9eae-709e-b326-8dc686666517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce01-9eae-709e-b326-8dc686666517",
        "storage_key": "property/6767906449166326/019fce01-9eae-709e-b326-8dc686666517.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.medstarhealth.org/locations/medstar-montgomery-medical-center?utm_campaign=mhs_citations&utm_medium=listing&utm_source=citation_management&utm_term=hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=16709316681260818028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medstar-montgomery-medical-center",
      "poi_latitude": "39.1537266",
      "poi_longitude": "-77.0547569",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 301-774-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-cd32-745f-b639-1fba5c34717a",
        "storage_key": "property/6767906449166326/019d0268-cd32-745f-b639-1fba5c34717a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyZAubuDQt4kRbF4P6v1q4-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b31d441a-9e68-4a5e-8b65-5a310c174a27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9d805182-6205-42ad-ba7d-df0bc0fa4a20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1ecf9f88-ecb8-4ce0-bdbd-093e748daf97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f6ea57d1-4e52-4086-a9ca-42a8be706bce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_99747d27-1abf-4f39-b80f-7a399512a5be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7f1944a8-2299-4dfa-9f34-e0e788c3c6b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f67d4c7e602b6c2b934e35d9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "rating": "5",
      "name": "Richie Rich",
      "text": "I don’t normally make reviews on things, I’m more of a reader but I had a remarkable exchange with someone in the leasing office earlier in the week. Jay was excellent about answering questions, helped me understand what I needed to inquire about the process of leasing an apartment and had overall great customer service. All that’s left is on my end, I plan to tour the complex soon. Hope she sees this shoutout Jay Francis!",
      "date": "2025-11-15",
      "title": "false"
    },
    {
      "id": "ec_72d8a8b143101933da16bbba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "rating": "5",
      "name": "Maria Marquez",
      "text": "I recently toured this apartments and was very impressed. The unit was clean, bright, and exactly as advertised. The leasing agent was professional, answered all my questions, and didn’t rush the tour. Common areas were well-kept, and everything from the appliances to the flooring looked in great condition. The whole process felt organized and transparent definitely a positive first impression. Tan was very helpful and was able to help us with everything we needed.",
      "date": "2025-08-15",
      "title": "false"
    },
    {
      "id": "ec_47ed5aedca7ffe0e01b21803",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "rating": "5",
      "name": "Alexis Diaz",
      "text": "I went to tour a 1 bed 1 bath for myself and my pet. Diana was my agent and I have to say I’ve never met someone like her. She’s outgoing very sweet, she has super good attention to detail and so much more that it’ll take me all day to type this. Overall the apartments were nice but not for me. But Diana went above and beyond showing me multiple units. If she hasn’t gotten a raise or promotion i don’t know what management is doing because she’s their star player. She was very beautiful as well. Diana is a 10/10 is every aspect.",
      "date": "2025-06-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4cbc2b51-bfb2-49e4-9008-421189f0b220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019ef82c-f689-7458-9cb9-5d202300cb7b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ef82c-f689-7458-9cb9-5d202300cb7b",
        "storage_key": "property/6767906449166326/019ef82c-f689-7458-9cb9-5d202300cb7b.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": " Landmark at Glenmont Station",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=636bba08e8b4e05c874d51ba&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_a8c62c24273660631cc3c2b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "429312",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_82e0303c79606436d6581729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "429314",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_a54159b66eb427bd8e4033d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "429317",
      "name": "Pet Rent",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_22bac3d0de709d535d9a86fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "429320",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cf066516e09b4eeefd530565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "536729",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 1,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c8b66def8d4ed0539c3e99c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "543060",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0553913a0a46f24fb9b8adfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "543061",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8cb37f0ef5e1f7610a78015c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "543062",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c9d969ed21a08b01bde37275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835132",
      "name": "Parking - Reserved/Covered",
      "description": "false",
      "amount": 40,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_72ccced4c44443463e7b83fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835133",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2ae01f5f269ff7a5ca5d132a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835136",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_694c8b82ada1346e81843bd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835140",
      "name": "Late Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e377c997bad2523432495db0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835147",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1a27c11e20c7e460daecc42c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "835150",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5ba1caa89f2abca0fa55392a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "engrain",
      "external_id": "838634",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1312-6c18-71b8-8afe-629aab93ac43",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-landmark-at-glenmont-station-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326"
    },
    {
      "lead_collector_id": "019c3043-6b65-72e9-aff0-c8b2c49b22b3",
      "lead_source": "FACEBOOK_ADS",
      "name": "landmark-at-glenmont-station",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326"
    },
    {
      "lead_collector_id": "019c3043-6bcf-7788-a456-08fd9de1f725",
      "lead_source": "LANDING_PAGE",
      "name": "landmark-at-glenmont-station",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "silver-spring-md-apartments-with-swimming-pool-527",
      "search_query": "apartments with swimming pool Silver Spring MD",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Silver Spring",
      "h2_subtitle": "Enjoy stylish living in Silver Spring, MD, with a swimming pool. Our pet-friendly community offers the ideal retreat with premium amenities.",
      "page_copy": "Discover the comfort and style of Landmark at Glenmont Station, where our Silver Spring, MD, apartments feature a sparkling swimming pool perfect for relaxation or fun. Choose from our spacious one- or two-bedroom homes that provide modern living amongst vibrant community features like grilling stations and a game room. \n\nEnjoy peace of mind with our bilingual property team and 24-hour maintenance support, ensuring seamless daily living. Whether you're lounging by the pool or enjoying the beautifully landscaped courtyard, you'll find everything you need just steps from your doorstep. Flexible leasing options make it easy to call Landmark home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Silver Spring Apartments with Pool",
      "seo_description": "Discover Silver Spring, MD, apartments with a pool at Landmark at Glenmont Station. Enjoy spacious homes with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "wheaton-glenmont-dog-park-apartments-412",
      "search_query": "dog park apartments in Wheaton-Glenmont",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Wheaton-Glenmont",
      "h2_subtitle": "Experience the perfect blend of comfort and pet-friendly amenities. Wheaton-Glenmont's vibrant community offers dog park apartments ready to welcome you home.",
      "page_copy": "Located in the heart of Wheaton-Glenmont, Landmark at Glenmont Station is where dog lovers and their furry companions find the perfect home. Our pet-friendly apartments offer access to pet amenities, including a nearby dog park designed for your pet's enjoyment and exercise. \n\nChoose between spacious one- and two-bedroom layouts in our community, equipped with conveniences like 24-hour maintenance, a bilingual team, and flexible lease options. While your pet enjoys the local dog park, you can relax at our swimming pool or host friends at our grilling stations. At Landmark, both you and your pet will discover a welcoming home in Wheaton-Glenmont.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wheaton-Glenmont Dog Park Apartments",
      "seo_description": "Find dog park apartments in Wheaton-Glenmont at Landmark at Glenmont Station. Pet-friendly living with great amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "montgomery-county-fitness-center-apartments-237",
      "search_query": "fitness center apartments Montgomery County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Montgomery County",
      "h2_subtitle": "Live well in Montgomery County with our fitness center-equipped apartments. Enjoy a healthy lifestyle in our vibrant community.",
      "page_copy": "Landmark at Glenmont Station offers residents in Montgomery County the perfect blend of fitness and convenience. While our community boasts many amenities, including a well-maintained swimming pool and scenic courtyards, it is the proximity to fitness facilities that makes staying active easier than ever.\n\nChoose from our range of spacious one- and two-bedroom apartment homes, each designed for modern living and comfort. Our bilingual staff and 24-hour maintenance ensure a seamless living experience, allowing you to focus on what matters most. With available short-term leases, it's never been easier to enjoy an active lifestyle in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Montgomery County Fitness Apartments",
      "seo_description": "Discover fitness center apartments in Montgomery County at Landmark at Glenmont Station. Enjoy active living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "bilingual-team-apartments-near-20906-640",
      "search_query": "bilingual team apartments near 20906",
      "category": "Amenity",
      "h1_title": "Bilingual Team Apartments Near 20906",
      "h2_subtitle": "Find a welcoming home near 20906 supported by a bilingual team. Our community offers friendly assistance to enhance your living experience.",
      "page_copy": "At Landmark at Glenmont Station, located near the 20906 area, you will find a welcoming community with a bilingual property team ready to assist you. Whether it's maintenance or leasing inquiries, our team is here to ensure you enjoy a smooth and hassle-free living experience.\n\nChoose from spacious one- or two-bedroom apartments equipped with modern comforts and access to premium amenities like a swimming pool and game room. Pet-friendly and offering flexible lease options, our community is designed to accommodate your needs while providing a warm and inclusive environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bilingual Team Apartments Near 20906",
      "seo_description": "Discover apartments near 20906 with a bilingual team at Landmark at Glenmont Station. Enjoy a welcoming, supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-silver-spring-md-838",
      "search_query": "pet friendly apartments in Silver Spring MD",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Silver Spring, MD",
      "h2_subtitle": "Discover your ideal pet-friendly home in Silver Spring, MD. Our community offers great amenities for both you and your furry friends.",
      "page_copy": "At Landmark at Glenmont Station, we understand that pets are part of the family. Located in Silver Spring, MD, our pet-friendly community welcomes you and your furry companions with open arms. Enjoy easy access to local dog parks and pet-friendly courtyards that allow your pets to explore and play freely.\n\nChoose from spacious one- and two-bedroom floor plans designed with comfort and convenience in mind. The amenities, including a sparkling swimming pool and grilling stations, provide relaxation opportunities for you, while our flexible lease options ensure a perfect fit for your lifestyle. Experience the warmth of a community that values both you and your pets at Landmark.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Silver Spring, MD",
      "seo_description": "Find pet-friendly apartments in Silver Spring, MD at Landmark at Glenmont Station. Enjoy amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-wheaton-glenmont-853",
      "search_query": "one bedroom apartments wheaton-glenmont",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Wheaton-Glenmont",
      "h2_subtitle": "Explore spacious one-bedroom apartments in Wheaton-Glenmont. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Discover the perfect one-bedroom apartment at Landmark at Glenmont Station, nestled in the vibrant Wheaton-Glenmont neighborhood. Our community offers comfortable and contemporary living spaces designed to fit your lifestyle, complemented by a host of amenities that include a sparkling pool, game room, and beautifully landscaped courtyards.\n\nLocated in a prime area, our one-bedroom apartments are not only spacious but also come with the advantage of a bilingual property team and flexible lease options. Whether you're looking for short-term leases or a long-term home, Landmark at Glenmont Station caters to your needs, creating an ideal environment in the heart of Wheaton-Glenmont.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments Wheaton-Glenmont",
      "seo_description": "Find spacious one-bedroom apartments in Wheaton-Glenmont at Landmark at Glenmont Station. Enjoy modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-silver-spring-md-822",
      "search_query": "two bedroom apartments silver spring md",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments Silver Spring, MD",
      "h2_subtitle": "Explore expansive two-bedroom apartments in Silver Spring, MD. Enjoy comfort and convenience in a lively community.",
      "page_copy": "Experience the perfect blend of comfort and convenience with our two-bedroom apartments at Landmark at Glenmont Station in Silver Spring, MD. These spacious layouts are designed with both style and functionality in mind, offering the ideal setting for families or roommates.\n\nLocated in a vibrant community, you'll have access to excellent amenities like a swimming pool, game room, and pet-friendly courtyards. Our bilingual team is ready to assist you with any needs, and with flexible rent options, living here is made easy. Discover your new home where every detail meets your expectations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Silver Spring, MD",
      "seo_description": "Find spacious two-bedroom apartments in Silver Spring, MD at Landmark at Glenmont Station. Enjoy modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-glenallan-elementary-wheaton-glenmont-852",
      "search_query": "apartments near glenallan elementary school wheaton-glenmont",
      "category": "School",
      "h1_title": "Apartments Near Glenallan Elementary School",
      "h2_subtitle": "Find the perfect home near Glenallan Elementary School in Wheaton-Glenmont. Ideal for families seeking convenience and quality living.",
      "page_copy": "Located just moments from Glenallan Elementary School, Landmark at Glenmont Station offers the ideal location for families in the Wheaton-Glenmont area. Our community provides easy access to quality education alongside spacious one- and two-bedroom apartments designed to fit your family's needs.\n\nExperience a plethora of amenities including a swimming pool, game room, and pet-friendly spaces that enhance family living. With the advantage of a bilingual property team and flexible leasing options, Landmark at Glenmont Station ensures a seamless living experience in the heart of a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Glenallan Elementary School",
      "seo_description": "Discover family-friendly apartments near Glenallan Elementary School in Wheaton-Glenmont at Landmark at Glenmont Station.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "landmark-at-glenmont-station-near-jfk-high-school-752",
      "search_query": "landmark at glenmont station close to john f. kennedy high school",
      "category": "School",
      "h1_title": "Landmark at Glenmont Station Near JFK High School",
      "h2_subtitle": "Live close to John F. Kennedy High School at Landmark at Glenmont Station. Enjoy a convenient and vibrant community.",
      "page_copy": "Situated conveniently near John F. Kennedy High School, Landmark at Glenmont Station is perfect for those seeking ease and accessibility in Silver Spring, MD. Our community offers spacious one- and two-bedroom apartments, providing a comfortable living space with plenty of room to grow.\n\nEnjoy a range of amenities, including a refreshing swimming pool, a lively game room, and extensive pet-friendly facilities. With a bilingual team dedicated to exceptional service and flexible rent options, Landmark at Glenmont Station provides an ideal setting for students and families alike, close to everything you need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Landmark at Glenmont Station Near JFK High School",
      "seo_description": "Discover comfortable living near JFK High School at Landmark at Glenmont Station with spacious apartments and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-argyle-middle-school-silver-spring-635",
      "search_query": "apartments near argyle middle school silver spring",
      "category": "School",
      "h1_title": "Apartments Near Argyle Middle School",
      "h2_subtitle": "Discover ideal living near Argyle Middle School in Silver Spring. Perfect for families wanting quality education and convenience.",
      "page_copy": "Landmark at Glenmont Station offers an exceptional living experience just a short distance from Argyle Middle School in Silver Spring. Our community is designed to meet the needs of families with spacious one- and two-bedroom apartment options, providing a comfortable and convenient lifestyle.\n\nEnjoy a vibrant community atmosphere with amenities such as a swimming pool, game room, and pet-friendly areas. Our bilingual staff is committed to providing excellent service, and with flexible leasing terms, you can enjoy peace of mind in a place that feels like home, right near top-notch schools.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Argyle Middle School",
      "seo_description": "Find family-friendly apartments near Argyle Middle School in Silver Spring at Landmark at Glenmont Station. Enjoy modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "landmark-at-glenmont-station-near-wheaton-high-school-938",
      "search_query": "landmark at glenmont close to wheaton high school montgomery county",
      "category": "School",
      "h1_title": "Landmark at Glenmont Near Wheaton High School",
      "h2_subtitle": "Enjoy proximity to Wheaton High School at Landmark at Glenmont Station in Montgomery County, offering convenience and quality living.",
      "page_copy": "Landmark at Glenmont Station is strategically located near Wheaton High School, making it an ideal choice for families and students in Montgomery County. Our community provides a variety of spacious one- and two-bedroom floor plans, ensuring a perfect fit for your lifestyle needs.\n\nWith enticing amenities such as a swimming pool, a game room, and pet-friendly accommodations, you'll find everything you need right at home. Additionally, our bilingual team and flexible rent options make living in this vibrant community effortlessly convenient. Experience the benefits of being close to quality education and the comforts of home at Landmark at Glenmont Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Landmark at Glenmont Near Wheaton High School",
      "seo_description": "Live near Wheaton High School in Montgomery County at Landmark at Glenmont Station. Discover convenience and comfort with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-barrie-school-silver-spring-md-124",
      "search_query": "apartments near Barrie School Silver Spring MD",
      "category": "School",
      "h1_title": "Apartments Near Barrie School in Silver Spring",
      "h2_subtitle": "Find your ideal home near Barrie School in Silver Spring, MD. Our community meets educational and living needs perfectly.",
      "page_copy": "Discover the perfect living experience at Landmark at Glenmont Station, conveniently located near Barrie School in Silver Spring, MD. Our community offers a selection of spacious one- and two-bedroom apartments, designed to accommodate families and individuals seeking both comfort and proximity to quality education.\n\nResidents enjoy a host of amenities, including a swimming pool, game room, and inviting pet-friendly spaces. With a dedicated bilingual team and options for short-term leases, Landmark at Glenmont Station provides an accommodating environment. Perfectly placed near Barrie School, it offers a convenient and vibrant lifestyle in the heart of Silver Spring.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Barrie School Silver Spring MD",
      "seo_description": "Discover spacious apartments near Barrie School in Silver Spring, MD, at Landmark at Glenmont Station. Enjoy convenience and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-holy-cross-hospital-silver-spring-621",
      "search_query": "apartments near Holy Cross Hospital Silver Spring",
      "category": "Hospital",
      "h1_title": "Apartments Near Holy Cross Hospital",
      "h2_subtitle": "Landmark at Glenmont Station offers ideal living near Holy Cross Hospital in Silver Spring, combining comfort with proximity.",
      "page_copy": "Situated conveniently near Holy Cross Hospital, Landmark at Glenmont Station presents an excellent choice for those in Silver Spring seeking easy access to healthcare facilities. Our community provides a range of spacious one- and two-bedroom apartments designed for comfortable living.\n\nResidents will enjoy modern amenities including a refreshing swimming pool, a fun-filled game room, and accommodating pet-friendly areas. With our bilingual team and flexible leasing options, Landmark at Glenmont Station meets diverse lifestyle needs. Make life simpler by choosing a home that offers both convenience and a vibrant living experience in Silver Spring.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holy Cross Hospital Silver Spring",
      "seo_description": "Discover convenience at Landmark at Glenmont Station, offering apartments near Holy Cross Hospital in Silver Spring with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "silver-spring-apartments-near-white-oak-medical-center-921",
      "search_query": "Silver Spring apartments near White Oak Medical Center",
      "category": "Hospital",
      "h1_title": "Silver Spring Apartments Near White Oak",
      "h2_subtitle": "Landmark at Glenmont Station offers convenient living near White Oak Medical Center in Silver Spring. Discover comfort and nearby healthcare access.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Landmark at Glenmont Station, located near White Oak Medical Center in Silver Spring. Our spacious one- and two-bedroom apartments are ideal for healthcare professionals and anyone seeking proximity to top medical facilities.\n\nEnjoy a host of amenities, including a relaxing swimming pool, engaging game room, and pet-friendly areas. Our bilingual team is ready to assist with flexible renting options that cater to diverse needs. Choose Landmark at Glenmont Station for a vibrant community feel and easy access to medical care and other Silver Spring attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Silver Spring Apartments Near White Oak",
      "seo_description": "Live near White Oak Medical Center at Landmark at Glenmont Station. Enjoy comfort and convenience in Silver Spring with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "silver-spring-apartments-near-glenmont-greenway-park-773",
      "search_query": "silver spring apartments near glenmont greenway urban park",
      "category": "Park",
      "h1_title": "Silver Spring Apartments by Glenmont Park",
      "h2_subtitle": "Live near Glenmont Greenway Urban Park at Landmark at Glenmont Station in Silver Spring, offering nature and modern living combined.",
      "page_copy": "Nestled near the scenic Glenmont Greenway Urban Park, Landmark at Glenmont Station offers a perfect retreat in Silver Spring. Our spacious one- and two-bedroom apartments provide the ideal setting for those who value green spaces and city conveniences.\n\nResidents benefit from first-rate amenities, including a revitalizing swimming pool, an entertaining game room, and inviting pet-friendly areas. Our bilingual property team ensures a seamless living experience with options tailored to your leasing needs. Embrace a lifestyle enriched by nature and community at Landmark at Glenmont Station, where comfort meets outdoor adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Silver Spring Apartments by Glenmont Park",
      "seo_description": "Enjoy nature and comfort at Landmark at Glenmont Station, near Glenmont Greenway Park in Silver Spring, featuring modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "wheaton-glenmont-rentals-near-glenfield-local-park-128",
      "search_query": "wheaton-glenmont rentals close to glenfield local park",
      "category": "Park",
      "h1_title": "Wheaton-Glenmont Rentals by Glenfield Park",
      "h2_subtitle": "Discover rentals near Glenfield Local Park in Wheaton-Glenmont. Landmark at Glenmont Station provides the perfect balance of nature and comfort.",
      "page_copy": "Discover an exceptional living experience at Landmark at Glenmont Station, situated close to Glenfield Local Park in Wheaton-Glenmont. Our one- and two-bedroom rentals offer a harmonious blend of nature and modern convenience, ideal for those who prioritize outdoor leisure and accessibility.\n\nWith a host of amenities such as a sparkling swimming pool, relaxing game room, and welcoming pet-friendly spaces, our community caters to diverse lifestyles. The bilingual team is committed to providing flexible rental options and top-notch service. Explore the serene environment of Wheaton-Glenmont while enjoying the comforts of home at Landmark at Glenmont Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Glenfield Park in Wheaton-Glenmont",
      "seo_description": "Find your home at Landmark at Glenmont Station, offering rentals near Glenfield Local Park in Wheaton-Glenmont with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-saddlebrook-park-montgomery-county-381",
      "search_query": "apartments near saddlebrook local park montgomery county",
      "category": "Park",
      "h1_title": "Apartments Near Saddlebrook Park, Montgomery",
      "h2_subtitle": "Enjoy living near Saddlebrook Local Park in Montgomery County. Landmark at Glenmont Station offers convenience and nature together in one community.",
      "page_copy": "Live in a vibrant community at Landmark at Glenmont Station, conveniently located near Saddlebrook Local Park in Montgomery County. Our spacious one- and two-bedroom apartments provide easy access to serene park settings while offering the comforts of modern living.\n\nExperience a range of amenities including a tranquil swimming pool, entertainment-packed game room, and pet-friendly environment. Managed by a bilingual team, we ensure hassle-free living with flexible leasing options. At Landmark at Glenmont Station, enjoy the best of both worlds—green spaces and luxurious comforts right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saddlebrook Park, Montgomery",
      "seo_description": "Discover Landmark at Glenmont Station, located near Saddlebrook Local Park in Montgomery County, offering stylish apartments with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "silver-spring-md-apartments-glenmont-local-park-418",
      "search_query": "silver spring md apartments by glenmont local park",
      "category": "Park",
      "h1_title": "Silver Spring Apartments by Glenmont Park",
      "h2_subtitle": "Explore Silver Spring, MD apartments near Glenmont Local Park at Landmark at Glenmont Station. Experience comfort and access to nature.",
      "page_copy": "Located in Silver Spring, MD, Landmark at Glenmont Station presents an inviting community, just a short distance from Glenmont Local Park. Our spacious one- and two-bedroom apartments are designed for those seeking a balanced lifestyle with access to both nature and urban conveniences.\n\nResidents at Landmark enjoy diverse amenities including a refreshing swimming pool, cozy game room, and pet-friendly facilities. The bilingual property team ensures ease with flexible rental agreements and prompt maintenance services. Come home to a seamless blend of nature and city living in Silver Spring at Landmark at Glenmont Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Silver Spring Apartments by Glenmont Park",
      "seo_description": "Find your home at Landmark at Glenmont Station, near Glenmont Local Park in Silver Spring, MD. Enjoy modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "apartments-near-glenmont-transit-646",
      "search_query": "apartments near Glenmont transit",
      "category": "Transit",
      "h1_title": "Apartments Near Glenmont Transit Station",
      "h2_subtitle": "Discover convenient apartments near Glenmont Transit Station. Experience comfortable living at Landmark at Glenmont Station with exceptional amenities.",
      "page_copy": "If you're looking for apartments near Glenmont Transit, Landmark at Glenmont Station is your ideal choice. Located in Silver Spring's vibrant community, our one- and two-bedroom floor plans offer unmatched convenience and comfort, perfect for commuters.\n\nEnjoy our comprehensive amenities, including a pristine swimming pool and a lively game room. Our pet-friendly environment and bilingual property team ensure that you feel right at home. Plus, flexible leasing options and 24-hour maintenance services enhance your living experience. Choose Landmark at Glenmont Station and benefit from easy access to the Glenmont Transit Station, making your daily commute a breeze.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Glenmont Transit Station",
      "seo_description": "Live at Landmark at Glenmont Station, with apartments near Glenmont Transit Station. Enjoy comfortable living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166326",
      "source": "custom",
      "page_item_url": "silver-spring-md-apartments-near-transit-271",
      "search_query": "Silver Spring MD apartments near transit",
      "category": "Transit",
      "h1_title": "Silver Spring MD Apartments Near Transit",
      "h2_subtitle": "Explore Silver Spring MD apartments conveniently located near transit options. Landmark at Glenmont Station offers effortless living with prime amenities.",
      "page_copy": "Landmark at Glenmont Station presents beautifully designed Silver Spring MD apartments, ideally situated near major transit options. Nestled in the bustling Wheaton-Glenmont neighborhood, our community offers easy access to public transportation facilities, providing a perfect blend of convenience and comfort.\n\nChoose from our spacious one- and two-bedroom layouts, and enjoy exceptional amenities like a swimming pool, game room, and pet-friendly policies. Our dedicated bilingual team offers flexible leasing terms and round-the-clock maintenance services, ensuring a seamless living experience. With the comfort and ease of transit at your doorstep, Landmark at Glenmont Station is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lifeguard stand, with apartment buildings in the background.",
        "public_id": "019fce00-fa46-7288-9319-8326a58aeae5",
        "storage_key": "property/6767906449166326/019fce00-fa46-7288-9319-8326a58aeae5.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Silver Spring MD Apartments Near Transit",
      "seo_description": "Find Silver Spring MD apartments at Landmark at Glenmont Station, located near transit, offering comfortable living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5063"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976261129"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973397"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KCC98HXT"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://landmarkatglenmontstation.fatwin.com/api/websites/resources/1?x=Vm04blFJcUN3aHdiY1FEWEpQZmJXL3VleUNXV1I3aUhzMXhWaHhtUjNLcUh5WDVKRkZvSzh2WHppMmlQbjVQbjNJRExmd0lvcE56LzlHQ0xvOHpTZHc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52814059121"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/n9w61933v71"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95487622-43e6-11ef-85ef-5736d51eb44b"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95487622-43e6-11ef-85ef-5736d51eb44b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95487622-43e6-11ef-85ef-5736d51eb44b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdaSXA4NWhITVl5WGpSWEwrZEtpamc9PSIsInZhbHVlIjoiR0ZyYXNPM0hjR3Z1WWJ3M1poY1pCdz09IiwibWFjIjoiMDEyZGMxOTA5ZDYxNTFjNWUyZWFiYWJjNTk0MjBjNDhhMzE0ZDI4MjBkMWQwMGVkMGM1NTNlOTY0YjMxYzYyZSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5063",
  "custom_repli_id": "9976261129",
  "custom_realpage_id": "4973397",
  "custom_google_gtm_id": "GTM-KCC98HXT",
  "custom_perq_script_url": "https://landmarkatglenmontstation.fatwin.com/api/websites/resources/1?x=Vm04blFJcUN3aHdiY1FEWEpQZmJXL3VleUNXV1I3aUhzMXhWaHhtUjNLcUh5WDVKRkZvSzh2WHppMmlQbjVQbjNJRExmd0lvcE56LzlHQ0xvOHpTZHc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "52814059121",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/n9w61933v71",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95487622-43e6-11ef-85ef-5736d51eb44b",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95487622-43e6-11ef-85ef-5736d51eb44b/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95487622-43e6-11ef-85ef-5736d51eb44b/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdaSXA4NWhITVl5WGpSWEwrZEtpamc9PSIsInZhbHVlIjoiR0ZyYXNPM0hjR3Z1WWJ3M1poY1pCdz09IiwibWFjIjoiMDEyZGMxOTA5ZDYxNTFjNWUyZWFiYWJjNTk0MjBjNDhhMzE0ZDI4MjBkMWQwMGVkMGM1NTNlOTY0YjMxYzYyZSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "bedb386e-00fe-4cbf-aef1-006cdd6952a9",
  "custom_audioeye_site_hash": "113656155e474f9901dd958446b80ff3"
};

export const generatedAt = '2026-10-22T20:06:49.552Z';
